<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Sales Order {{ salesOrderNo }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom left>
        <v-btn icon slot="activator" class="white--text">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(item, i) in menuItems" :key="i" @click="clickMenu(item.title)">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-layout>
        <v-flex xs12>
          <v-card class="pa-4">
            <v-container fluid grid-list-xs>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="mb-3">
                  Sales Order
                  <h1 class="text-xs-left headline font-weight-bold orange--text text--lighten-2">
                    <span id="spanOrderNo">{{ salesOrderNo }}</span>
                    <v-icon small class="ml-3 notranslate" @click="copyToClipbpard(salesOrderNo); selectTextInElement('spanOrderNo');">file_copy</v-icon>
                  </h1>
                  <h3 class="text-xs-left body-2 font-weight-medium"><span v-for="(invoice, invoiceIndex) in invoiceNos" class="mr-4" :key="invoiceIndex">{{ invoice.invoiceNo }}</span></h3>
                  <div class="mt-3">
                    <v-rating
                      empty-icon="star"
                      background-color="grey darken-2"
                      color="orange"
                      :size=14
                      half-increments
                      :value="review.reviewRating"
                      readonly
                      dense
                    ></v-rating>
                    <div v-if="review.reviewRating > 0">
                      <div class="caption grey--text">{{ review.reviewDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</div>
                      <div class="font-italic">" {{ review.review }} "</div>
                      <v-btn
                        v-if="review.reviewReply === ''"
                        outline
                        small
                        round
                        class="ml-0 mr-2"
                        @click="showReplyReviewDialog"
                      >
                        Reply
                      </v-btn>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap>
                          <v-flex xs3 md2 v-for="(file, fileIndex) in review.reviewFiles" :key="file.reviewFileId">
                            <v-img v-if="file.type === 'photo'" :src="file.url" aspect-ratio="1" style="border: 1px solid #ababab; cursor: pointer;" @click="showReviewImageDialog(fileIndex)" />
                            <div v-else-if="file.type === 'video'" style="position:relative;">
                              <v-img :src="file.url" aspect-ratio="1" style="border: 1px solid #ababab; cursor: pointer;" @click="showReviewImageDialog(fileIndex)" />
                              <v-btn dark absolute fab style="top:50%;left:50%;transform: translate(-50%, -50%);" @click="showReviewImageDialog(fileIndex)">
                                <v-icon>play_arrow</v-icon>
                              </v-btn>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                      <div v-if="review.reviewReply !== ''" class="pa-3 ml-3 mt-3" style="border:1px solid #ff9900;">
                        <div class="caption grey--text">Replied by {{ review.reviewRepliedByAdminName }} on {{ review.reviewRepliedDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</div>
                        <div class="font-italic">" {{ review.reviewReply }} "</div>
                        <v-btn
                          icon
                          class="ml-0 mr-2 grey--text"
                          @click="showReplyReviewDialog"
                        >
                          <v-icon small>edit</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="review.reviewRequestedDateTime !== ''" class="caption">
                        <div>
                          Review requested at {{ review.reviewRequestedDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                          by {{ review.reviewRequestedByAdminName }}
                        </div>
                        <v-btn
                          outline
                          small
                          class="ml-0 mr-2"
                          @click="requestReview"
                        >
                          Request again
                        </v-btn>
                      </div>
                      <div v-else>
                        <v-btn
                          outline
                          small
                          class="ml-0 mr-2"
                          @click="requestReview"
                        >
                          Request for customer review
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 class="mb-3 text-xs-left text-sm-right">
                  <v-btn
                    outline
                    class="ml-0 mr-2"
                    @click="refreshOrder"
                  >
                    Refresh Status
                  </v-btn>
                  <v-btn
                    outline
                    class="ml-0 mr-2"
                    @click="downloadInvoice"
                  >
                    Download Invoice
                  </v-btn>
                  <v-btn
                    outline
                    class="ml-0 mr-0"
                    v-if="deliveryStatus !== 'sent' && deliveryStatus !== 'delivered'"
                    :to="'/order/' + salesOrderNo + '/edit'"
                  >
                    Edit Order
                  </v-btn>
                </v-flex>
                <v-flex xs12 class="mb-3">
                  By: {{ loginEmail }}
                  <v-btn
                    outline
                    small
                    class="ml-2 mr-1"
                    :to="'/customer/' + userId + '/orders'"
                  >
                    History
                  </v-btn>
                  <v-btn
                    outline
                    small
                    v-if="isAccessTransaction"
                    class="mr-1"
                    :to="'/customer/' + userId + '/transactions'"
                  >
                    Transactions
                  </v-btn>
                  <v-btn
                    outline
                    small
                    :to="'/ticket?buyer=' + userId + '&order=' + salesOrderNo"
                  >Send Message</v-btn>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs6 sm3 md3 lg2>
                        <span class="font-weight-bold">Created Date</span>
                      </v-flex>
                      <v-flex xs6 sm9 md9 lg10>
                        {{ createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12 v-if="paymentStatus === 'none'">
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 v-if="paymentStatus === 'none'">
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs6 sm3 md3 lg2>
                        <span class="font-weight-bold">Expiry Date</span>
                      </v-flex>
                      <v-flex xs6 sm9 md9 lg10>
                        {{ expiryDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12 v-if="paymentStatus === 'paid' || paymentStatus === 'credit'">
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 v-if="paymentStatus === 'paid' || paymentStatus === 'credit'">
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs6 sm3 md3 lg2>
                        <span class="font-weight-bold">Payment Date</span>
                      </v-flex>
                      <v-flex xs6 sm9 md9 lg10>
                        {{ paidDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs6 sm3 md3 lg2>
                        <span class="font-weight-bold">Order Type</span>
                      </v-flex>
                      <v-flex xs6 sm9 md9 lg10 class="font-weight-bold">
                        {{ orderType | allCaps }}<span v-if="createdByAdminName" class="ml-2 caption font-weight-light">(Created by: {{ createdByAdminName }} on {{ createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }})</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-container fluid grid-list-xs class="pt-0 pb-0 pl-2">
                    <v-layout row wrap>
                      <v-flex xs6 sm3 md3 lg2 style="padding-top:12px;padding-left:0;">
                        <span class="font-weight-bold">Payment Status</span>
                      </v-flex>
                      <v-flex xs6 sm9 md9 lg10>
                        <v-chip :color="paymentStatusColor" text-color="white" style="min-width:130px;">
                          <v-avatar>
                            <v-icon small class="notranslate">{{ paymentStatusIcon }}</v-icon>
                          </v-avatar>
                          <strong>{{ paymentStatus.toUpperCase() }}</strong>
                        </v-chip>
                        <v-btn
                          outline
                          small
                          class="ml-0 mr-0"
                          style="width:130px;"
                          :to="'/order/' + salesOrderNo + '/payments'"
                        >
                          View
                        </v-btn>
                        <v-btn
                          v-if="paymentStatus !== 'paid' && paymentStatus !== 'credit' && paymentStatus !== 'none'"
                          outline
                          small
                          class="ml-0 mr-0"
                          style="width:130px;"
                          @click="dialogVerificationRequest = !dialogVerificationRequest"
                        >
                          Verify
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-container fluid grid-list-xs class="pt-0 pb-0 pl-2">
                    <v-layout row wrap>
                      <v-flex xs6 sm3 md3 lg2 style="padding-top:12px;padding-left:0;">
                        <span class="font-weight-bold">Delivery Status</span>
                      </v-flex>
                      <v-flex xs6 sm9 md9 lg10>
                        <v-chip :color="deliveryStatusColor" text-color="white" style="min-width:130px;">
                          <v-avatar>
                            <v-icon small class="notranslate">{{ deliveryStatusIcon }}</v-icon>
                          </v-avatar>
                          <strong>{{ deliveryStatus.toUpperCase() }}</strong>
                        </v-chip>
                        <v-btn
                          outline
                          small
                          class="ml-0 mr-0"
                          style="width:130px;"
                          :to="'/shipments/' + salesOrderNo"
                        >
                          View
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-divider class="mb-3"></v-divider>
                </v-flex>
                <v-flex xs12 v-if="isChargebackUser === '1'" class="mb-3">
                  <v-container fluid grid-list-xs class="red darken-2 pa-3">
                    <v-layout row wrap>
                      <v-flex xs3 sm1 class="text-xs-center">
                        <v-avatar>
                          <v-icon class="large notranslate white red--text">priority_high</v-icon>
                        </v-avatar>
                      </v-flex>
                      <v-flex xs5 sm8>
                        <h3 class="title font-weight-bold white--text">Chargeback User</h3>
                        On {{ userChargebackDateTime | formatDate('DD MMMM YYYY', profile.gmtTimezone) }}
                      </v-flex>
                      <v-flex xs4 sm3 class="text-xs-right">
                        <v-btn
                          outline
                          class="mr-2"
                          :to="'/customer/' + userId + '/orders'"
                        >
                          View
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12 sm6>
                  <strong>Bill to:</strong>
                  <br>{{ billingTitle }} {{ billingFirstName }} {{ billingLastName }}
                  <span v-if="billingCompany"><br>{{ billingCompany }}</span>
                  <br>{{ billingAddress }}
                  <br>{{ billingCityName }}, {{ billingProvinceName }}
                  <br>{{ billingPostCode }}, {{ billingCountryName }}
                  <span v-if="billingTaxId"><br>Tax ID{{ (billingTaxIdLocalName.length > 0 ? ' (' + billingTaxIdLocalName + ')' : '') }}: {{ billingTaxId }}</span>
                  <br>{{ billingPhone }}
                  <br>{{ billingEmail }}
                  <br>
                  <v-btn
                    outline
                    small
                    class="ml-0 mt-3 mb-5"
                    @click="showSimilarOrders"
                  >
                    Fraud Scan
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6>
                  <strong>Ship to:</strong>
                  <br>{{ shippingTitle }} {{ shippingFirstName }} {{ shippingLastName }}
                  <span v-if="shippingCompany"><br>{{ shippingCompany }}</span>
                  <br>{{ shippingAddress }}
                  <br>{{ shippingCityName }}, {{ shippingProvinceName }}
                  <br>{{ shippingPostCode }}, {{ shippingCountryName }}
                  <span v-if="shippingTaxId"><br>Tax ID{{ (shippingTaxIdLocalName.length > 0 ? ' (' + shippingTaxIdLocalName + ')' : '') }}: {{ shippingTaxId }}</span>
                  <br>{{ shippingPhone }}
                  <br>{{ shippingEmail }}
                  <div v-if="shippingLatitude !== 0 && shippingLongitude !== 0">
                    <v-img :src="getStaticMapUrl(shippingLatitude, shippingLongitude, 200, 200, 16)" aspect-ratio="1" max-width="200" max-height="200" class="mt-3" style="border: 1px solid #ababab;"></v-img>
                    <div>
                      <v-btn
                        small
                        @click="showMapView"
                      >
                        View
                      </v-btn>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 class="mt-2 mb-4">
                  <strong>Remarks:</strong>
                  <div v-html="(remarks ? remarks : '-')"></div>
                </v-flex>
                <v-flex xs12>
                  <v-divider class="mt-3"></v-divider>
                </v-flex>
                <v-flex xs12 sm6 class="mt-4">
                  <strong>Payment Method:</strong>
                  <br>{{ paymentMethodName }}
                </v-flex>
                <v-flex xs12 sm6 class="mt-4">
                  <strong>Tax Declaration:</strong>
                  <br>Declared value: {{ declareValuePercentage }}%
                </v-flex>
                <v-flex xs12>
                  <v-divider class="mt-3"></v-divider>
                </v-flex>
                <v-flex xs12 sm6 class="mt-5">
                  <div style="overflow-y:scroll;height:500px;border:1px solid #555555;" class="pa-4" ref="timelineDiv">
                    <timeline>
                      <timeline-title class="orange--text text--lighten-2 font-weight-bold title">Order Notes</timeline-title>
                      <timeline-item v-for="(event, eventIndex) in events" :key="eventIndex" bg-color="#ffffff" class="white--text">
                        <span class="caption">{{ event.createdDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</span>
                        <div class="font-weight-bold">{{ event.title }} <v-icon v-if="event.noteId && event.isSellerVisible === '1'" class="ml-2 green--text" small title="Seller visible">visibility</v-icon></div>
                        <div v-html="event.description"></div>
                        <v-btn v-if="event.deliveryOrderNo"
                          outline
                          small
                          :href="'/shipment/' + event.deliveryOrderNo"
                          target="_blank"
                        >
                          View
                        </v-btn>
                        <v-btn v-if="event.paymentId"
                          outline
                          small
                          :href="'/payment/' + event.paymentId"
                          target="_blank"
                        >
                          View
                        </v-btn>
                        <v-btn v-if="event.verificationId"
                          outline
                          small
                          @click="viewVerificationRequest(event.verificationId)"
                        >
                          View
                        </v-btn>
                      </timeline-item>
                    </timeline>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 class="mt-5 pa-4">
                  <v-form ref="frmNotes" v-model="frmNotesValid">
                    <v-container fluid grid-list-md>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-textarea
                            outline
                            v-model="txtNotes"
                            label="Add your notes"
                            :rules="[v => !!v || 'Notes is required']"
                            required
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12>
                          <v-switch
                            v-model="switchNoteSellerVisible"
                            color="primary"
                            label="Seller Visible"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 class="mt-3">
                          <div class="font-weight-bold">UPLOADED FILES</div>
                          <v-list v-if="noteFileUploads.length > 0" style="background-color:transparent;">
                            <template v-for="(file, fileIndex) in noteFileUploads">
                              <v-list-tile
                                :key="fileIndex"
                              >
                                <v-list-tile-content>
                                  <v-list-tile-title class="body-2">
                                    {{ file.name }}
                                    <v-btn
                                      icon
                                      small
                                      class="ml-2 mr-0 mt-0 mb-0"
                                      @click="removeFileUpload(fileIndex)"
                                    >
                                      <v-icon small>close</v-icon>
                                    </v-btn>
                                    <span v-if="file.uploadStatus && file.uploadStatus === 'success'" class="green--text ml-3">
                                      <v-icon small color="green" class="mr-1">done</v-icon>
                                      Uploaded
                                    </span>
                                    <span v-if="file.uploadStatus && file.uploadStatus === 'uploading'" class="orange--text ml-3">
                                      <v-icon small color="orange" class="mr-1">hourglass_empty</v-icon>
                                      Uploading
                                    </span>
                                    <span v-if="file.uploadStatus && file.uploadStatus === 'error'" class="red--text ml-3">
                                      <v-icon small color="red" class="mr-1">close</v-icon>
                                      Upload failed
                                    </span>
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                          </v-list>
                          <input
                            type="file"
                            multiple
                            style="display: none"
                            ref="filePicker"
                            accept="*"
                            @change="onFilePicked"
                            @click="$refs.filePicker.value = null"
                          >
                          <div>
                            <span v-if="noteFileUploads.length === 0" class="grey--text">No file uploaded</span>
                            <v-btn
                              outline
                              small
                              v-if="noteFileUploads.length < 3"
                              @click="pickFile"
                            >
                              Add file
                            </v-btn>
                          </div>
                        </v-flex>
                        <v-flex xs12 class="mt-5">
                          <v-btn
                            outline
                            class="ml-0 pl-5 pr-5"
                            :disabled="!frmNotesValid"
                            @click="addNotes(txtNotes, switchNoteSellerVisible)"
                          >
                            Add Notes
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-flex>
                <v-flex xs12 class="text-xs-left mt-5">
                  <user-notes-box v-model="userNotes" :userId="userId"></user-notes-box>
                </v-flex>
                <v-flex xs12 class="text-xs-center mt-5 mb-5">
                  <h4 class="title font-weight-bold mb-3">Shipping Route</h4>
                  <center>
                    <table class="diagram" border=0 cellspacing="10" width="100%">
                      <tr v-for="(route, routeIndex) in routing" :key="routeIndex">
                        <td height="100%">
                          <div v-if="route.shipForSellers" class="diagram-box" style="height: 100%;">
                            <div v-for="(seller, sellerIndex) in route.shipForSellers" :key="sellerIndex" class="ma-3">
                              <strong>{{ seller.storeName }} ({{ seller.storeCityName }})</strong> -
                              <span v-if="seller.deliveryStatus === 'sent'">
                                Sent <v-icon color="green lighten-2">check_circle_outline</v-icon>
                              </span>
                              <span v-else-if="seller.deliveryStatus === 'partial'">
                                Partial <v-icon color="orange darken-1">opacity</v-icon>
                              </span>
                              <span v-else>
                                Pending <v-icon>hourglass_empty</v-icon>
                              </span>
                              ({{ formatPrice(seller.shippingWeight, 1) }} kg)
                              <v-btn small outline v-for="deliveryOrder in seller.deliveryOrders" :key="deliveryOrder.deliveryOrderNo" :to="'/shipment/' + deliveryOrder.deliveryOrderNo">
                                View {{ deliveryOrder.deliveryOrderNo }}
                              </v-btn>
                            </div>
                          </div>
                        </td>
                        <td>
                          <v-icon v-if="route.shipForSellers">arrow_forward</v-icon>
                        </td>
                        <td class="diagram-box">
                          <div v-if="route.deliveryStatus === 'sent'">
                            <v-icon medium color="green lighten-2">check_circle_outline</v-icon>
                            <br>Sent
                          </div>
                          <div v-else-if="route.deliveryStatus === 'partial'">
                            <v-icon medium color="orange darken-1">opacity</v-icon>
                            <br>Partially sent
                          </div>
                          <div v-else>
                            <v-icon medium>hourglass_empty</v-icon>
                            <br>Pending
                          </div>
                          <div class="mt-1">
                            <strong>{{ route.storeName }}</strong>
                            <br>{{ route.courierName }} - {{ route.serviceCode }} ({{ formatPrice(route.shippingWeight, 1) }} kg)
                          </div>
                          <div v-if="route.deliveryOrders.length > 0">
                            <v-btn small outline v-for="deliveryOrder in route.deliveryOrders" :key="deliveryOrder.deliveryOrderNo" :to="'/shipment/' + deliveryOrder.deliveryOrderNo">
                              View {{ deliveryOrder.deliveryOrderNo }}
                            </v-btn>
                          </div>
                        </td>
                        <td>
                          <v-icon>arrow_forward</v-icon>
                        </td>
                        <td class="diagram-box" :rowspan="routing.length" v-if="routeIndex === 0">
                          <div v-if="deliveryStatus === 'sent'">
                            <v-icon medium color="green lighten-2">check_circle_outline</v-icon>
                            <br>Sent
                          </div>
                          <div v-else-if="deliveryStatus === 'partial'">
                            <v-icon medium color="orange darken-1">opacity</v-icon>
                            <br>Partially sent
                          </div>
                          <div v-else>
                            <v-icon medium>hourglass_empty</v-icon>
                            <br>Pending
                          </div>
                          <div class="mt-1">
                            <strong>CUSTOMER</strong>
                            <br>{{ shippingProvinceName }}, {{ shippingCountryName }}
                          </div>
                        </td>
                      </tr>
                    </table>
                  </center>
                </v-flex>

                <v-flex xs12 class="text-xs-center">
                  <v-expansion-panel class="mt-5" v-if="(deliveryStatus === 'sent' || deliveryStatus === 'delivered') && cacheProfitStatus">
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div><h2 :class="(cacheProfitInBase > 0 ? 'green--text' : 'red--text text--lighten-1')">Profit {{ def.currency.sign + formatPrice(cacheProfitInBase, def.currency.decimals, def.currency.decimalSign) }} <span :class="'subheading ' + getCostStatusColor(cacheProfitStatus)">({{ cacheProfitStatus | capitalize }})</span></h2></div>
                      </template>
                      <v-card flat class="pt-0">
                        <v-container fluid grid-list-xs class="pt-0">
                          <v-layout row wrap>
                            <v-flex
                              xs12
                              text-xs-center
                              layout
                              align-center
                              justify-center
                              class="mt-0"
                            >
                              <v-divider></v-divider>
                              <v-data-table
                                flat
                                :items="[{a: ''}]"
                                hide-actions
                                class="pt-0 mt-0"
                                style="width: 100%;"
                                hide-headers
                              >
                                <template slot="footer">
                                  <tr>
                                    <td width="70%" class="text-xs-left subheading font-weight-regular">
                                      <strong>Branch</strong> <span :class="'body-2 ml-2 ' + getCostStatusColor(cacheBranchCostPriceStatus)">({{ cacheBranchCostPriceStatus | capitalize }})</span>
                                      <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                        <tr>
                                          <td width="60%" class="no-border body-2 font-weight-regular">
                                            Total Sales
                                          </td>
                                          <td width="30%" class="no-border body-2 font-weight-regular">
                                            {{ def.currency.sign + formatPrice(cacheBranchSalesInBase, def.currency.decimals, def.currency.decimalSign) }}
                                          </td>
                                          <td width="10%" class="no-border body-2 font-weight-regular">
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="no-border body-2 font-weight-regular">
                                            Total Cost
                                            <div class="caption grey--text">({{ def.currency.sign + formatPrice(cacheCostPriceInBaseFundedByHQ, def.currency.decimals, def.currency.decimalSign) }} funded by HQ)</div>
                                          </td>
                                          <td class="no-border body-2 font-weight-regular" style="border-bottom:1px solid #ffffff;">
                                            {{ def.currency.sign + formatPrice(cacheBranchCostInBase, def.currency.decimals, def.currency.decimalSign) }}
                                          </td>
                                          <td class="no-border subheading font-weight-regular">
                                            -
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colspan=3>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td width="30%" class="text-xs-right subheading font-weight-bold" valign="bottom">
                                      {{ def.currency.sign + formatPrice(cacheBranchSalesInBase - cacheBranchCostInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-xs-left subheading font-weight-regular">
                                      <strong>Seller Fee</strong> <span :class="'body-2 ml-2 ' + getCostStatusColor(deliveryStatus)">({{ (deliveryStatus === 'sent' || deliveryStatus === 'delivered' ? 'Complete' : deliveryStatus) | capitalize }})</span>
                                      <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                        <tr v-for="(seller, sellerIndex) in sellers" :key="seller.sellerUserId">
                                          <td width="60%" class="no-border body-2 font-weight-regular">
                                            {{ seller.storeName }} ({{ seller.storeCountryName }})
                                          </td>
                                            <td width="30%" class="no-border body-2 font-weight-regular" :style="(sellerIndex >= (sellers.length - 1) ? 'border-bottom:1px solid #ffffff;' : '')">
                                            {{ def.currency.sign + formatPrice(seller.feeAmountInBase, def.currency.decimals, def.currency.decimalSign) }}
                                          </td>
                                          <td width="10%" class="no-border subheading font-weight-regular">
                                            <span v-if="sellerIndex >= (sellers.length - 1)">+</span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colspan=3>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td class="text-xs-right subheading font-weight-bold" valign="bottom">
                                      {{ def.currency.sign + formatPrice(cacheSellerFeeInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-xs-left subheading font-weight-regular">
                                      <strong>Shipping (for branches)</strong> <span :class="'body-2 ml-2 ' + getCostStatusColor(cacheBranchRealShippingCostStatus)">({{ cacheBranchRealShippingCostStatus | capitalize }})</span>
                                      <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                        <tr>
                                          <td width="60%" class="no-border body-2 font-weight-regular">
                                            Collected Shipping Cost
                                          </td>
                                          <td width="30%" class="no-border body-2 font-weight-regular">
                                            {{ def.currency.sign + formatPrice(cacheBranchShippingCostInBase, def.currency.decimals, def.currency.decimalSign) }}
                                          </td>
                                          <td width="10%" class="no-border body-2 font-weight-regular">
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="no-border body-2 font-weight-regular">
                                            Real Shipping Cost
                                            <v-btn
                                              small
                                              outline
                                              class="ml-3"
                                              :to="'/shipments/' + salesOrderNo"
                                            >
                                              View
                                            </v-btn>
                                          </td>
                                          <td class="no-border body-2 font-weight-regular" style="border-bottom:1px solid #ffffff;">
                                            {{ def.currency.sign + formatPrice(cacheBranchRealShippingCostInBase, def.currency.decimals, def.currency.decimalSign) }}
                                          </td>
                                          <td class="no-border subheading font-weight-regular">
                                            -
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colspan=3>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td class="text-xs-right subheading font-weight-bold" valign="bottom">
                                      {{ def.currency.sign + formatPrice(cacheBranchShippingCostInBase - cacheBranchRealShippingCostInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-xs-left subheading font-weight-regular">
                                      <strong>Payment</strong> <span :class="'body-2 ml-2 ' + getCostStatusColor(cachePaymentRealFeeStatus)">({{ cachePaymentRealFeeStatus | capitalize }})</span>
                                      <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                        <tr>
                                          <td width="60%" class="no-border body-2 font-weight-regular">
                                            Total Fee Received
                                          </td>
                                          <td width="30%" class="no-border body-2 font-weight-regular">
                                            {{ def.currency.sign + formatPrice(cachePaymentFeeReceivedInBase, def.currency.decimals, def.currency.decimalSign) }}
                                          </td>
                                          <td width="10%" class="no-border body-2 font-weight-regular">
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="no-border body-2 font-weight-regular">
                                            Total Real Fee
                                            <v-btn
                                              small
                                              outline
                                              class="ml-3"
                                              :to="'/order/' + salesOrderNo + '/payments'"
                                            >
                                              View
                                            </v-btn>
                                          </td>
                                          <td class="no-border body-2 font-weight-regular" style="border-bottom:1px solid #ffffff;">
                                            {{ def.currency.sign + formatPrice(cachePaymentRealFeeInBase, def.currency.decimals, def.currency.decimalSign) }}
                                          </td>
                                          <td class="no-border subheading font-weight-regular">
                                            -
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colspan=3>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td class="text-xs-right subheading font-weight-bold" valign="bottom">
                                      {{ def.currency.sign + formatPrice(cachePaymentFeeReceivedInBase - cachePaymentRealFeeInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-xs-left subheading font-weight-regular">
                                      <strong>Payment Commission</strong> <span :class="'body-2 ml-2 ' + getCostStatusColor(cachePaymentCommissionStatus)">({{ cachePaymentCommissionStatus | capitalize }})</span>
                                      <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                        <tr v-for="(payment, paymentIndex) in payments" :key="payment.paymentId">
                                          <td width="60%" class="no-border body-2 font-weight-regular">
                                            {{ payment.paymentMethodName }} ({{ def.currency.sign + formatPrice(payment.amountInBase, def.currency.decimals, def.currency.decimalSign) }})
                                            <span v-if="payment.receivedOnBehalfBySellerUserId !== ''" class="caption grey--text ml-2">by {{ payment.receivedOnBehalfBySellerLoginEmail }}</span>
                                          </td>
                                            <td width="30%" class="no-border body-2 font-weight-regular" :style="(paymentIndex >= (payments.length - 1) ? 'border-bottom:1px solid #ffffff;' : '')">
                                            {{ def.currency.sign + formatPrice(payment.paymentCommissionAmountInBase, def.currency.decimals, def.currency.decimalSign) }}
                                          </td>
                                          <td width="10%" class="no-border subheading font-weight-regular">
                                            <span v-if="paymentIndex >= (payments.length - 1)">+</span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colspan=3>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td class="text-xs-right subheading font-weight-bold" valign="bottom">
                                      {{ def.currency.sign + formatPrice(cachePaymentCommissionInBase * -1, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-xs-left subheading font-weight-regular">
                                      <strong>Extra Cost</strong>
                                      <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                        <tr v-for="(cost, costIndex) in extraCosts" :key="cost.extraCostId">
                                          <td width="60%" class="no-border body-2 font-weight-regular">
                                            <div>
                                              {{ cost.name }}
                                              <v-btn
                                                small
                                                icon
                                                class="mr-0 grey--text text--darken-1"
                                                @click="showDeleteExtraCostDialog(costIndex)"
                                              >
                                                <v-icon small>delete</v-icon>
                                              </v-btn>
                                              <v-btn
                                                small
                                                icon
                                                class="ml-0 grey--text text--darken-1"
                                                @click="showEditExtraCostDialog(costIndex)"
                                              >
                                                <v-icon small>edit</v-icon>
                                              </v-btn>
                                            </div>
                                            <div class="caption grey--text text--darken-1">
                                              <span v-if="cost.updatedByAdminName.length > 0">Updated by {{ cost.updatedByAdminName }} on {{ cost.updatedDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</span>
                                              <span v-else-if="cost.createdByAdminName.length > 0">Created by {{ cost.createdByAdminName }} on {{ cost.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</span>
                                            </div>
                                          </td>
                                          <td width="30%" class="no-border body-2 font-weight-regular" :style="(costIndex >= (extraCosts.length - 1) ? 'border-bottom:1px solid #ffffff;' : '')">
                                            {{ def.currency.sign + formatPrice(cost.amountInBase, def.currency.decimals, def.currency.decimalSign) }}
                                            <span v-if="cost.currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text ml-3">({{ cost.currencySign }}{{ formatPrice(cost.amount, cost.currencyDecimals, cost.currencyDecimalSign) }})</span>
                                          </td>
                                          <td width="10%" class="no-border subheading font-weight-regular">
                                            <span v-if="costIndex >= (extraCosts.length - 1)">+</span>
                                          </td>
                                        </tr>
                                      </table>
                                      <v-btn
                                        small
                                        outline
                                        class="ml-4"
                                        @click="showAddExtraCostDialog"
                                      >
                                        Add Cost
                                      </v-btn>
                                    </td>
                                    <td class="text-xs-right subheading font-weight-bold" valign="bottom">
                                      {{ def.currency.sign + formatPrice(cacheExtraCostInBase * -1, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-xs-left subheading font-weight-regular">
                                      <strong>Profit</strong>
                                    </td>
                                    <td :class="'text-xs-right headline font-weight-bold ' + (cacheProfitInBase > 0 ? 'green--text' : 'red--text text--lighten-1')" valign="bottom">
                                      {{ def.currency.sign + formatPrice(cacheProfitInBase, def.currency.decimals, def.currency.decimalSign) }}
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>

              </v-layout>
            </v-container>
            <v-container fluid grid-list-xs>
              <v-layout row wrap>
                <v-flex
                  xs12
                  text-xs-left
                  layout
                >
                  <v-checkbox
                    class="ml-1 mt-3"
                    color="primary"
                    label="Select all costing items"
                    v-model="chkBulkCostItems"
                    @change="selectAllCostingCheckboxes(chkBulkCostItems)"
                  ></v-checkbox>
                </v-flex>
                <v-flex
                  xs12
                  text-xs-center
                  layout
                  align-center
                  justify-center
                >
                  <v-data-table
                    flat
                    :items="orderItems"
                    hide-actions
                    class="pt-0"
                    style="width: 100%;"
                  >
                    <template slot="headers">
                      <tr class="grey darken-4">
                        <th class="text-xs-center subheading font-weight-bold white--text">
                          Seller
                        </th>
                        <th class="text-xs-center subheading font-weight-bold white--text" colspan="2">
                          Details
                        </th>
                        <th class="text-xs-center subheading font-weight-bold white--text hidden-xs-only">
                          Status
                        </th>
                        <th class="text-xs-center subheading font-weight-bold white--text">
                          Qty
                        </th>
                        <th class="text-xs-center subheading font-weight-bold white--text hidden-xs-only" width="250">
                          Unit Cost Price
                        </th>
                        <th class="text-xs-center subheading font-weight-bold white--text hidden-xs-only">
                          Unit Price
                        </th>
                        <th class="text-xs-center subheading font-weight-bold white--text hidden-xs-only">
                          Sub Total
                        </th>
                      </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                      <td valign="top" class="pa-1 pt-3 pb-3" style="max-width: 120px;">
                        {{ props.item.storeName | allCaps }}
                        <v-btn
                          outline
                          small
                          class="mr-1"
                          v-if="isAccessTransaction"
                          :to="'/customer/' + props.item.sellerUserId + '/transactions'"
                        >
                          Balance
                        </v-btn>
                      </td>
                      <td valign="top" class="pa-1 pt-3 pb-3" style="max-width: 120px;">
                        <img v-if="props.item.image" :src="props.item.image" class="cart-item-thumb">
                        <div v-else style="width:100%; height: 70px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
                        <div class="caption">Unit weight: {{ formatPrice(props.item.unitWeight) }}kg</div>
                        <div class="caption" v-if="props.item.shippingSubsidyAmount && props.item.shippingSubsidyAmount > 0">
                          <span class="font-weight-bold green--text">{{ currencySign }}{{ formatPrice(props.item.shippingSubsidyAmount, currencyDecimals, currencyDecimalSign) }} Free Shipping</span>
                          with {{ props.item.shippingSubsidyCourierName }} {{ props.item.shippingSubsidyServiceName }}
                        </div>
                      </td>
                      <td valign="top" class="pa-2 pt-3 pb-3 text-xs-left body-1 font-weight-regular">
                        <a :href="def.marketplaceDomain + props.item.url" class="white--text" target="_blank"><strong>{{ props.item.name }}</strong></a>
                        <div class="caption item-identity" :data-param-hash="props.item.paramHash">{{ props.item.sku }}</div>
                        <div class="caption">
                          <div v-for="param in props.item.itemParams" :key="param.name">
                            <span class="font-weight-medium">{{ param.name }}: </span>
                            <span v-if="param.value">
                              <a v-if="param.value.toLowerCase().substring(0, 7) === 'http://' || param.value.toLowerCase().substring(0, 8) === 'https://'" :href="param.value" target="_blank">
                                {{ param.value }}
                              </a>
                              <span v-else>
                                {{ param.value }}
                              </span>
                            </span>
                            <div v-if="param.selections">
                              <div v-for="selection in param.selections" :key="selection.name">
                                {{ selection.name }} <span v-if="selection.priceInBase > 0">({{ currencySign + formatPrice(selection.priceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }})</span><span v-else-if="selection.price > 0">({{ currencySign + formatPrice(selection.price, currencyDecimals, currencyDecimalSign) }})</span> <span v-if="selection.weight > 0">({{ formatPrice(selection.weight) }}kg)</span>
                              </div>
                            </div>
                          </div>
                          <div v-for="option in props.item.options" :key="option.optionName">
                            <span class="font-weight-medium">{{ option.optionName }}:</span> <span>{{ option.valueName }}</span>
                          </div>
                          <div v-if="props.item.qty === 0" class="mt-2 mb-3">
                            <span class="red white--text pa-1 font-weight-bold">
                              <v-icon small color="white">remove_circle_outline</v-icon>
                              This item has been removed
                            </span>
                          </div>
                          <div v-else-if="props.item.originalQty !== props.item.qty" class="mt-2 mb-3">
                            <span class="orange white--text pa-1 font-weight-bold">
                              <v-icon small color="white">error_outline</v-icon>
                              Qty has been modified from {{ props.item.originalQty }} to {{ props.item.qty }}
                            </span>
                          </div>
                          <div v-else-if="props.item.isAdditionalItem === '1'" class="mt-2 mb-3">
                            <span class="orange white--text pa-1 font-weight-bold">
                              <v-icon small color="white">error_outline</v-icon>
                              Additional item
                            </span>
                          </div>
                          <div v-if="props.item.itemPreparedBy" class="mt-3">
                            <div><span class="font-weight-medium">Prepared by:</span> <span class="primary--text font-weight-bold">{{ props.item.itemPreparedBy }}</span></div>
                            <div><span class="font-weight-medium">Status:</span> <span>{{ props.item.deliveryStatus }}</span></div>
                            <div><span class="font-weight-medium">Seller sent qty:</span> <span>{{ props.item.incomingQty }} of {{ props.item.qty }}</span></div>
                          </div>
                          <div>
                            <div v-if="props.item.issues.length > 0">
                              <div class="body-1 font-weight-bold mt-3">Issues:</div>
                              <div v-for="issue in props.item.issues" :key="issue.ticketId" class="mb-4">
                                <div class="font-weight-bold">{{ issue.title }}</div>
                                <div class="caption">By {{ issue.createdByUserStoreName }} ({{ issue.createdByUserTitle }} {{ issue.createdByUserFirstName }} {{ issue.createdByUserLastName }}) - {{ issue.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }} - <span v-if="issue.status === 'closed'" class="font-weight-bold green--text">{{ issue.status | allCaps }}</span><span v-else class="font-weight-bold red--text">{{ issue.status | allCaps }}</span></div>
                                <div class="caption">
                                  <div v-for="msg in issue.messages" :key="msg.ticketMessageId">
                                    <v-divider class="mt-2 mb-2"></v-divider>
                                    <v-layout>
                                      <v-flex xs3 class="text-xs-center">
                                        <div v-if="msg.createdByUserId.length > 0">
                                          <div class="font-weight-bold">{{ msg.createdByUserStoreName }}</div>
                                          <div>{{ msg.createdByUserTitle }} {{ msg.createdByUserFirstName }} {{ msg.createdByUserLastName }}</div>
                                        </div>
                                        <div v-else-if="msg.createdByAdminId.length > 0">
                                          <div class="font-weight-bold">Admin</div>
                                          <div>{{ msg.createdByAdminName }}</div>
                                        </div>
                                      </v-flex>
                                      <v-flex xs9>
                                        <div>{{ msg.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</div>
                                        <div class="font-weight-bold" v-html="msg.message"></div>
                                        <div v-if="msg.files && msg.files.length > 0" class="text-xs-left mt-3">
                                          <div class="font-weight-bold">Uploaded files</div>
                                          <ul>
                                            <li v-for="file in msg.files" :key="file.ticketFileId">
                                              <a :href="file.url" class="white--text text--darken-3">{{ file.fileName }}</a>
                                            </li>
                                          </ul>
                                        </div>
                                      </v-flex>
                                    </v-layout>
                                  </div>
                                  <v-divider class="mt-2 mb-2"></v-divider>
                                  <v-btn
                                    outline
                                    small
                                    class="ml-0"
                                    @click="showReplyIssueDialog(issue.ticketId)"
                                  >
                                    Reply
                                  </v-btn>
                                  <v-btn
                                    outline
                                    small
                                    class="ml-0"
                                    v-if="issue.status === 'open'"
                                    @click="showCloseIssueDialog(issue.ticketId)"
                                  >
                                    Close Case
                                  </v-btn>
                                  <v-btn
                                    outline
                                    small
                                    class="ml-0"
                                    v-if="issue.status === 'closed'"
                                    @click="showReopenIssueDialog(issue.ticketId)"
                                  >
                                    Reopen Case
                                  </v-btn>
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <v-btn
                                outline
                                small
                                @click="showAddIssueDialog(props.item)"
                              >
                                Open issue
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="pa-2 body-2 text-xs-center caption hidden-xs-only">
                        <span v-if="props.item.qty === 0">
                          <v-icon medium color="red darken-1">remove_circle_outline</v-icon>
                          <br>Removed
                        </span>
                        <span v-else-if="props.item.qtySentToCustomer >= props.item.qty">
                          <v-icon medium color="green lighten-2">check_circle_outline</v-icon>
                          <br>Sent
                        </span>
                        <span v-else-if="props.item.qtySentToCustomer > 0">
                          <v-icon medium color="orange darken-1">opacity</v-icon>
                          <br>Partial
                        </span>
                        <span v-else-if="props.item.qtySentToBranch >= props.item.qty">
                          <v-icon medium color="orange darken-1">opacity</v-icon>
                          <br>Sent to branch
                        </span>
                        <span v-else-if="props.item.qtySentToBranch > 0">
                          <v-icon medium color="orange darken-1">opacity</v-icon>
                          <br>Partially sent to branch
                        </span>
                        <span v-else>
                          <v-icon medium>hourglass_empty</v-icon>
                          <br>Pending
                        </span>
                      </td>
                      <td class="pa-2 body-2 text-xs-center subheading font-weight-bold">
                        {{ (props.item.qty > 0 ? props.item.qty : props.item.originalQty) }}
                      </td>
                      <td class="pa-2 body-2 text-xs-center subheading font-weight-bold hidden-xs-only">
                        <div v-if="!isAccessCosting">
                          -
                        </div>
                        <div v-else-if="(props.item.storeType === 'branch' || props.item.isPricingManagedByMV === '1') && props.item.qty > 0">
                          <v-container fluid grid-list-lg class="pa-0">
                            <v-layout row wrap>
                              <v-flex xs12 class="font-weight-regular caption pb-0">
                                <div v-if="props.item.productCostPrice > 0" :class="((props.item.productCostPrice * props.item.productCurrencyExchangeRateToBase) < props.item.unitPriceInBase ? 'grey--text' : 'red--text')">
                                  Current cost price:
                                  {{ props.item.productCurrencySign }}{{ formatPrice(props.item.productCostPrice, props.item.productCurrencyDecimals, props.item.productCurrencyDecimalSign) }}
                                  <span v-if="props.item.productCurrencyCode !== def.currency.currencyCode">
                                    ({{ def.currency.sign }}{{ formatPrice(props.item.productCostPrice * props.item.productCurrencyExchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }})
                                  </span>
                                </div>
                                <div v-else>
                                  Item have no cost price
                                </div>
                              </v-flex>
                              <v-flex xs1 class="pa-0 ma-0">
                                <v-checkbox
                                  class="pt-3"
                                  color="primary"
                                  v-model="props.item.chkCostPrice"
                                  label=""
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs4>
                                <v-select
                                  v-model="props.item.costPriceCurrencyCode"
                                  v-bind:items="currencies"
                                  item-text="sign"
                                  item-value="currencyCode"
                                  hide-details
                                  :disabled="props.item.qtySentToCustomer < props.item.qty || (props.item.isSkipCostPrice === 1 || props.item.isSkipCostPrice === true)"
                                  @change="isCostPriceChange = true; props.item.costPriceExchangeRateToBase = getRateToBase(props.item.costPriceCurrencyCode); props.item.saveButtonStatus = '';"
                                ></v-select>
                              </v-flex>
                              <v-flex xs7>
                                <v-text-field
                                  v-model="props.item.costPrice"
                                  hide-details
                                  :disabled="props.item.qtySentToCustomer < props.item.qty || (props.item.isSkipCostPrice === 1 || props.item.isSkipCostPrice === true)"
                                  @keyup="props.item.saveButtonStatus = ''"
                                  @change="isCostPriceChange = true"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs4 text-xs-center class="grey--text" v-if="props.item.costPriceCurrencyCode.length > 0 && props.item.costPriceCurrencyCode !== def.currency.currencyCode">
                                Rate to USD
                              </v-flex>
                              <v-flex xs8 v-if="props.item.costPriceCurrencyCode.length > 0 && props.item.costPriceCurrencyCode !== def.currency.currencyCode">
                                <v-text-field
                                  v-model="props.item.costPriceExchangeRateToBase"
                                  hide-details
                                  :disabled="props.item.qtySentToCustomer < props.item.qty || (props.item.isSkipCostPrice === 1 || props.item.isSkipCostPrice === true)"
                                  @keyup="props.item.saveButtonStatus = ''"
                                  @change="isCostPriceChange = true"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs4 text-xs-center class="grey--text">
                                Fund from HQ
                              </v-flex>
                              <v-flex xs8>
                                <v-text-field
                                  v-model="props.item.costPriceFundedByHQ"
                                  hide-details
                                  :disabled="props.item.qtySentToCustomer < props.item.qty || (props.item.isSkipCostPrice === 1 || props.item.isSkipCostPrice === true)"
                                  @keyup="props.item.saveButtonStatus = ''"
                                  @change="isCostPriceChange = true"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 text-xs-center class="caption">
                                <span v-if="props.item.costPriceCurrencyCode !== def.currency.currencyCode && props.item.costPrice > 0 && props.item.costPriceExchangeRateToBase > 0" class="caption font-weight-light grey--text mr-3">{{ def.currency.sign }}{{ formatPrice(props.item.costPrice * props.item.costPriceExchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }}</span>
                                <span v-if="props.item.costPriceCurrencyCode !== currencyCode && currencyCode !== def.currency.currencyCode && props.item.costPrice > 0 && props.item.costPriceExchangeRateToBase > 0" class="caption font-weight-light grey--text mr-3">{{ currencySign }}{{ formatPrice((props.item.costPrice * props.item.costPriceExchangeRateToBase) / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }}</span>
                                <span v-if="props.item.costPrice > 0 && props.item.costPriceExchangeRateToBase > 0">
                                  <span v-if="(props.item.costPrice * props.item.costPriceExchangeRateToBase) < props.item.unitPriceInBase" class="caption font-weight-bold green--text">
                                    <v-icon small color="green lighten-2">check</v-icon>
                                    {{ def.currency.sign }}{{ formatPrice(props.item.unitPriceInBase - (props.item.costPrice * props.item.costPriceExchangeRateToBase), def.currency.decimals, def.currency.decimalSign) }} Profit
                                  </span>
                                  <span v-else class="caption font-weight-black red--text text--darken-1">
                                    <v-icon small color="red darken-1">error_outline</v-icon>
                                    {{ def.currency.sign }}{{ formatPrice((props.item.costPrice * props.item.costPriceExchangeRateToBase) - props.item.unitPriceInBase, def.currency.decimals, def.currency.decimalSign) }} Loss
                                  </span>
                                </span>
                              </v-flex>
                              <v-flex xs12 text-xs-center v-if="props.item.costPriceUpdatedDateTime" class="caption grey--text">
                                Updated {{ props.item.costPriceUpdatedDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}
                                <span v-if="props.item.costPriceUpdatedByAdminName">by {{ props.item.costPriceUpdatedByAdminName }}</span>
                              </v-flex>
                              <v-flex xs6 text-xs-center>
                                <v-switch
                                  v-model="props.item.isSkipCostPrice"
                                  color="primary"
                                  label="Skip"
                                  class="caption font-weight-regular"
                                  hide-details
                                  @change="isCostPriceChange = true; props.item.saveButtonStatus = '';"
                                ></v-switch>
                              </v-flex>
                              <v-flex xs6 text-xs-center>
                                <v-btn
                                  @click="showOverrideProductCostPriceDialog(props.item)"
                                  outline
                                  block
                                  small
                                  :disabled="!isEnableSaveCostButton(props.item)"
                                >
                                  <v-progress-circular
                                    v-if="props.item.saveButtonStatus === 'saving'"
                                    indeterminate
                                    small
                                    color="primary"
                                    :width=3
                                    class="ma-3"
                                    dark
                                  ></v-progress-circular>
                                  <span v-else-if="props.item.saveButtonStatus === 'success'">
                                    <v-icon medium color="green">check_circle_outline</v-icon>
                                  </span>
                                  <span v-else>
                                    Save
                                  </span>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </div>
                        <div v-else-if="props.item.qty === 0" class="font-weight-regular grey--text text--darken-1">
                          -
                        </div>
                        <div v-else class="font-weight-regular grey--text text--darken-1">
                          Non-branch item
                        </div>
                      </td>
                      <td class="pa-2 body-2 text-xs-center subheading font-weight-bold hidden-xs-only">
                        <div>{{ currencySign + formatPrice(props.item.unitPrice, currencyDecimals, currencyDecimalSign) }}</div>
                        <div v-if="currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">{{ def.currency.sign }}{{ formatPrice(props.item.unitPrice * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }}</div>
                      </td>
                      <td class="pa-2 body-2 text-xs-center subheading font-weight-bold hidden-xs-only">
                        <div>{{ currencySign + formatPrice(props.item.qty * props.item.unitPrice, currencyDecimals, currencyDecimalSign) }}</div>
                        <div v-if="currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">{{ def.currency.sign }}{{ formatPrice((props.item.qty * props.item.unitPrice) * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }}</div>
                      </td>
                    </template>
                    <template slot="footer">
                      <tr>
                        <td colspan=5 class="text-xs-left subheading font-weight-medium">
                          Subtotal
                        </td>
                        <td colspan=3 class="text-xs-right subheading font-weight-bold">
                          <div>{{ currencySign + formatPrice(cacheTotalSales, currencyDecimals, currencyDecimalSign) }}</div>
                          <div v-if="currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">{{ def.currency.sign }}{{ formatPrice(cacheTotalSales * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan=5 class="text-xs-left subheading font-weight-regular">
                          <strong>Shipping Cost</strong>
                          <table border=0 width="100%">
                            <tr v-for="(route, routeIndex) in routing" :key="routeIndex">
                              <td width="100%" class="no-border body-2 font-weight-regular">
                                From {{ route.storeName }} - {{ route.storeCityName }} ({{ formatPrice(route.shippingWeight) }}kg):
                                {{ route.courierName}} {{ route.serviceCode}} ({{ currencySign + formatPrice(route.deliveryCostBeforeSubsidy, currencyDecimals, currencyDecimalSign) }}) <span v-if="currencyCode !== def.currency.currencyCode" class="ml-2 caption font-weight-light grey--text">({{ def.currency.sign }}{{ formatPrice(route.deliveryCostBeforeSubsidy * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }})</span>
                                <div class="caption font-weight-bold green--text" v-if="route.shippingSubsidy > 0">
                                  - Free Shipping {{ currencySign + formatPrice(route.shippingSubsidy, currencyDecimals, currencyDecimalSign) }}
                                  <span v-if="currencyCode !== def.currency.currencyCode" class="ml-2 caption font-weight-light grey--text">({{ def.currency.sign + formatPrice(route.shippingSubsidy * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }})</span>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td colspan=3 class="text-xs-right subheading font-weight-bold">
                          <div>{{ currencySign + formatPrice(deliveryCost, currencyDecimals, currencyDecimalSign) }}</div>
                          <div v-if="currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">{{ def.currency.sign }}{{ formatPrice(deliveryCost * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan=5 class="text-xs-left subheading font-weight-regular">
                          <strong>Import Duties</strong>
                          <table border=0 width="100%">
                            <tr v-for="(route, routeIndex) in routing" :key="routeIndex">
                              <td width="100%" class="no-border body-2 font-weight-regular">
                                From {{ route.storeName }} - {{ route.storeCountryName }}:
                                {{ currencySign + formatPrice(route.importTariff, currencyDecimals, currencyDecimalSign) }} <span v-if="currencyCode !== def.currency.currencyCode" class="ml-2 caption font-weight-light grey--text">({{ def.currency.sign }}{{ formatPrice(route.importTariff * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }})</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td colspan=3 class="text-xs-right subheading font-weight-bold">
                          <div>{{ currencySign + formatPrice(importTariff, currencyDecimals, currencyDecimalSign) }}</div>
                          <div v-if="currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">{{ def.currency.sign }}{{ formatPrice(importTariff * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }}</div>
                        </td>
                      </tr>
                      <template v-if="vouchers && vouchers.length > 0">
                        <tr v-for="(voucher, voucherIndex) in vouchers" :key="voucher.voucherCode">
                          <td colspan=5 class="text-xs-left subheading font-weight-medium">
                            <div>Voucher</div>
                            <div class="caption">
                              {{ voucher.name + ' - ' + voucher.voucherCode }}
                              <v-btn
                                icon
                                small
                                class="caption font-weight-medium ma-0 pa-0 mb-1 ml-2"
                                @click="showDeleteVoucherDialog(voucherIndex)"
                              >
                                <v-icon small>delete_outline</v-icon>
                              </v-btn>
                            </div>
                            <div v-if="voucher.valid !== '1'" class="caption red--text">
                              {{ voucher.invalidReason }}
                            </div>
                          </td>
                          <td colspan=3 class="text-xs-right subheading font-weight-bold">
                            <div>-{{ currencySign }}{{ formatPrice(voucher.discountAmountInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }}</div>
                          </td>
                        </tr>
                      </template>
                      <tr>
                        <td colspan=5 class="text-xs-left subheading font-weight-medium">
                          <div>Grand Total</div>
                          <div v-if="currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">Rate: {{ exchangeRateToBase }}</div>
                        </td>
                        <td colspan=3 class="text-xs-right title font-weight-bold">
                          <div>{{ currencySign + formatPrice(Math.max((cacheTotalSales + deliveryCost + importTariff) - cacheTotalVoucherDiscount, 0), currencyDecimals, currencyDecimalSign) }}</div>
                          <div v-if="currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">{{ def.currency.sign }}{{ formatPrice(Math.max(((cacheTotalSales + deliveryCost + importTariff) - cacheTotalVoucherDiscount) * exchangeRateToBase, 0), def.currency.decimals, def.currency.decimalSign) }}</div>
                        </td>
                      </tr>
                      <tr v-for="item in paymentDiscounts" :key="item.paymentId">
                        <td colspan=8 class="text-xs-left orange--text">
                          <div>Discount for {{ item.paymentMethodName }} payment: ${{ formatPrice(item.feeAmountInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }}</div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs6 class="mt-4">
                  <div class="text-xs-left caption" v-if="isAccessCosting && (deliveryStatus === 'sent' || deliveryStatus === 'delivered')">
                    <v-btn
                      outline
                      class="ml-1"
                      @click="showBulkCostEditingDialog"
                    >
                      Set Cost for Selected Items
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs6 class="mt-4">
                  <div class="text-xs-right caption" v-if="paymentStatus !== 'paid' && paymentStatus !== 'credit'">
                    <v-btn
                      small
                      flat
                      class="mr-1 orange--text"
                      @click="showAddVoucherDialog"
                    >
                      Add Voucher
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
            <!--<v-btn
              block
              large
              color="primary"
              class="mt-4"
              :disabled="!isCostPriceChange"
              @click="saveCostPrice"
            >Save Cost Price</v-btn>-->

          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="bulkCostEditingDialog" @keydown.esc="bulkCostEditingDialog = false" max-width="900px">
        <v-card>
          <v-card-title>
            <h3 class="headline font-weight-bold mb-0">Item Costing</h3>
          </v-card-title>
          <v-card-text>
            <v-form ref="frmBulkCostEditing" v-model="bulkCostEditingValid" class="mt-0" @submit.prevent="">
              <v-data-table
                flat
                :items="bulkCostEditingItems"
                hide-actions
                class="pt-0"
                style="width: 100%;"
              >
                <template slot="headers">
                  <tr class="grey darken-4">
                    <th class="text-xs-center subheading font-weight-bold white--text">
                      Seller
                    </th>
                    <th class="text-xs-center subheading font-weight-bold white--text" colspan="2">
                      Details
                    </th>
                    <th class="text-xs-center subheading font-weight-bold white--text">
                      Qty
                    </th>
                    <th class="text-xs-center subheading font-weight-bold white--text hidden-xs-only" width="250">
                      Unit Cost Price
                    </th>
                    <th class="text-xs-center subheading font-weight-bold white--text hidden-xs-only">
                      Unit Price
                    </th>
                    <th class="text-xs-center subheading font-weight-bold white--text">
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td valign="top" class="pa-1 pt-3 pb-3 text-xs-center" style="max-width: 120px;">
                    {{ props.item.storeName | allCaps }}
                  </td>
                  <td valign="top" class="pa-1 pt-3 pb-3" style="max-width: 120px;">
                    <img v-if="props.item.image" :src="props.item.image" class="cart-item-thumb">
                    <div v-else style="width:100%; height: 70px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
                  </td>
                  <td valign="top" class="pa-2 pt-3 pb-3 text-xs-left body-1 font-weight-regular">
                    <a :href="def.marketplaceDomain + props.item.url" class="white--text" target="_blank"><strong>{{ props.item.name }}</strong></a>
                    <div class="caption item-identity" :data-param-hash="props.item.paramHash">{{ props.item.sku }}</div>
                    <div class="caption">
                      <div v-for="param in props.item.itemParams" :key="param.name">
                        <span class="font-weight-medium">{{ param.name }}: </span>
                        <span v-if="param.value">
                          <a v-if="param.value.toLowerCase().substring(0, 7) === 'http://' || param.value.toLowerCase().substring(0, 8) === 'https://'" :href="param.value" target="_blank">
                            {{ param.value }}
                          </a>
                          <span v-else>
                            {{ param.value }}
                          </span>
                        </span>
                        <div v-if="param.selections">
                          <div v-for="selection in param.selections" :key="selection.name">
                            {{ selection.name }} <span v-if="selection.priceInBase > 0">({{ currencySign + formatPrice(selection.priceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }})</span><span v-else-if="selection.price > 0">({{ currencySign + formatPrice(selection.price, currencyDecimals, currencyDecimalSign) }})</span> <span v-if="selection.weight > 0">({{ formatPrice(selection.weight) }}kg)</span>
                          </div>
                        </div>
                      </div>
                      <div v-for="option in props.item.options" :key="option.optionName">
                        <span class="font-weight-medium">{{ option.optionName }}:</span> <span>{{ option.valueName }}</span>
                      </div>
                      <div v-if="props.item.qty === 0" class="mt-2 mb-3">
                        <span class="red white--text pa-1 font-weight-bold">
                          <v-icon small color="white">remove_circle_outline</v-icon>
                          This item has been removed
                        </span>
                      </div>
                      <div v-else-if="props.item.originalQty !== props.item.qty" class="mt-2 mb-3">
                        <span class="orange white--text pa-1 font-weight-bold">
                          <v-icon small color="white">error_outline</v-icon>
                          Qty has been modified from {{ props.item.originalQty }} to {{ props.item.qty }}
                        </span>
                      </div>
                      <div v-else-if="props.item.isAdditionalItem === '1'" class="mt-2 mb-3">
                        <span class="orange white--text pa-1 font-weight-bold">
                          <v-icon small color="white">error_outline</v-icon>
                          Additional item
                        </span>
                      </div>
                      <div v-if="props.item.itemPreparedBy" class="mt-3">
                        <div><span class="font-weight-medium">Prepared by:</span> <span class="primary--text font-weight-bold">{{ props.item.itemPreparedBy }}</span></div>
                        <div><span class="font-weight-medium">Status:</span> <span>{{ props.item.deliveryStatus }}</span></div>
                        <div><span class="font-weight-medium">Seller sent qty:</span> <span>{{ props.item.incomingQty }} of {{ props.item.qty }}</span></div>
                      </div>
                    </div>
                  </td>
                  <td class="pa-2 body-2 text-xs-center subheading font-weight-bold">
                    {{ (props.item.qty > 0 ? props.item.qty : props.item.originalQty) }}
                  </td>
                  <td class="pa-2 body-2 text-xs-center subheading font-weight-bold hidden-xs-only">
                    <div v-if="!isAccessCosting">
                      -
                    </div>
                    <div v-else-if="(props.item.storeType === 'branch' || props.item.isPricingManagedByMV === '1') && props.item.qty > 0">
                      <v-container fluid grid-list-lg class="pa-0">
                        <v-layout row wrap>
                          <v-flex xs12 class="font-weight-regular caption pb-0">
                            <div v-if="props.item.productCostPrice > 0" :class="((props.item.productCostPrice * props.item.productCurrencyExchangeRateToBase) < props.item.unitPriceInBase ? 'grey--text' : 'red--text')">
                              Current cost price:
                              {{ props.item.productCurrencySign }}{{ formatPrice(props.item.productCostPrice, props.item.productCurrencyDecimals, props.item.productCurrencyDecimalSign) }}
                              <span v-if="props.item.productCurrencyCode !== def.currency.currencyCode">
                                ({{ def.currency.sign }}{{ formatPrice(props.item.productCostPrice * props.item.productCurrencyExchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }})
                              </span>
                            </div>
                            <div v-else>
                              Item have no cost price
                            </div>
                          </v-flex>
                          <v-flex xs5>
                            <v-select
                              v-model="props.item.costPriceCurrencyCode"
                              v-bind:items="currencies"
                              item-text="sign"
                              item-value="currencyCode"
                              hide-details
                              :rules="props.item.cboCurrencyRules"
                              :disabled="props.item.qtySentToCustomer < props.item.qty || (props.item.isSkipCostPrice === 1 || props.item.isSkipCostPrice === true)"
                              @change="props.item.costPriceExchangeRateToBase = getRateToBase(props.item.costPriceCurrencyCode); props.item.saveButtonStatus = '';"
                            ></v-select>
                          </v-flex>
                          <v-flex xs7>
                            <v-text-field
                              v-model="props.item.costPrice"
                              hide-details
                              :rules="props.item.txtCostPriceRules"
                              :disabled="props.item.qtySentToCustomer < props.item.qty || (props.item.isSkipCostPrice === 1 || props.item.isSkipCostPrice === true)"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5 text-xs-center class="grey--text" v-if="props.item.costPriceCurrencyCode.length > 0 && props.item.costPriceCurrencyCode !== def.currency.currencyCode">
                            Rate to USD
                            <v-btn
                              outline
                              small
                              class="pa-0 ml-0 mr-0 caption"
                              v-if="bulkCostEditingItems.length > 1 && props.item.costPriceExchangeRateToBase > 0 && (props.item.isSkipCostPrice === 0 || props.item.isSkipCostPrice === '0' || props.item.isSkipCostPrice === false)"
                              @click="showBulkCostEditingCopyRateConfirmation(props.index)"
                            >
                              Copy to all
                            </v-btn>
                          </v-flex>
                          <v-flex xs7 v-if="props.item.costPriceCurrencyCode.length > 0 && props.item.costPriceCurrencyCode !== def.currency.currencyCode">
                            <v-text-field
                              v-model="props.item.costPriceExchangeRateToBase"
                              hide-details
                              :disabled="props.item.qtySentToCustomer < props.item.qty || (props.item.isSkipCostPrice === 1 || props.item.isSkipCostPrice === true)"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5 text-xs-center class="pt-4 grey--text">
                            Fund from HQ
                          </v-flex>
                          <v-flex xs7>
                            <v-text-field
                              v-model="props.item.costPriceFundedByHQ"
                              hide-details
                              :disabled="props.item.qtySentToCustomer < props.item.qty || (props.item.isSkipCostPrice === 1 || props.item.isSkipCostPrice === true)"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 text-xs-center class="caption">
                            <span v-if="props.item.costPriceCurrencyCode !== def.currency.currencyCode && props.item.costPrice > 0 && props.item.costPriceExchangeRateToBase > 0" class="caption font-weight-light grey--text mr-3">{{ def.currency.sign }}{{ formatPrice(props.item.costPrice * props.item.costPriceExchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }}</span>
                            <span v-if="props.item.costPriceCurrencyCode !== currencyCode && currencyCode !== def.currency.currencyCode && props.item.costPrice > 0 && props.item.costPriceExchangeRateToBase > 0" class="caption font-weight-light grey--text mr-3">{{ currencySign }}{{ formatPrice((props.item.costPrice * props.item.costPriceExchangeRateToBase) / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }}</span>
                            <span v-if="props.item.costPrice > 0 && props.item.costPriceExchangeRateToBase > 0">
                              <span v-if="(props.item.costPrice * props.item.costPriceExchangeRateToBase) < props.item.unitPriceInBase" class="caption font-weight-bold green--text">
                                <v-icon small color="green lighten-2">check</v-icon>
                                {{ def.currency.sign }}{{ formatPrice(props.item.unitPriceInBase - (props.item.costPrice * props.item.costPriceExchangeRateToBase), def.currency.decimals, def.currency.decimalSign) }} Profit
                              </span>
                              <span v-else class="caption font-weight-black red--text text--darken-1">
                                <v-icon small color="red darken-1">error_outline</v-icon>
                                {{ def.currency.sign }}{{ formatPrice((props.item.costPrice * props.item.costPriceExchangeRateToBase) - props.item.unitPriceInBase, def.currency.decimals, def.currency.decimalSign) }} Loss
                              </span>
                            </span>
                          </v-flex>
                          <v-flex xs12 text-xs-center v-if="props.item.costPriceUpdatedDateTime" class="caption grey--text">
                            Updated {{ props.item.costPriceUpdatedDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}
                            <span v-if="props.item.costPriceUpdatedByAdminName">by {{ props.item.costPriceUpdatedByAdminName }}</span>
                          </v-flex>
                          <v-flex xs12 text-xs-center>
                            <v-switch
                              v-model="props.item.isSkipCostPrice"
                              color="primary"
                              label="Skip"
                              class="caption font-weight-regular"
                              @change="updateBulkCostingFieldRules(props.index)"
                              hide-details
                            ></v-switch>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                    <div v-else-if="props.item.qty === 0" class="font-weight-regular grey--text text--darken-1">
                      -
                    </div>
                    <div v-else class="font-weight-regular grey--text text--darken-1">
                      Non-branch item
                    </div>
                  </td>
                  <td class="pa-2 body-2 text-xs-center subheading font-weight-bold hidden-xs-only">
                    <div>{{ currencySign + formatPrice(props.item.unitPrice, currencyDecimals, currencyDecimalSign) }}</div>
                    <div v-if="currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">{{ def.currency.sign }}{{ formatPrice(props.item.unitPrice * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }}</div>
                  </td>
                  <td class="pa-2 body-2 text-xs-center subheading font-weight-bold">
                    <v-btn
                      icon
                      @click="deleteBulkCostItem(props.index)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
              <v-btn
                block
                color="primary"
                @click="saveBulkCostItem"
                :disabled="!bulkCostEditingValid"
              >
                Submit
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="bulkCostEditingCopyRateDialog"
        max-width="300"
      >
        <v-card>
          <v-card-title class="subheading font-weight-bold">Are you sure to copy rate of {{ bulkCostEditingCopyRate }} to all items under {{ bulkCostEditingCopyRateCurrencyCode }}?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              flat="flat"
              @click="bulkCostEditingCopyRateDialog = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="bulkCostEditingCopyRateToAll(bulkCostEditingCopyRateCurrencyCode, bulkCostEditingCopyRate)"
            >
              Copy
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogVerificationRequest" @keydown.esc="dialogVerificationRequest = false" max-width="900px">
        <v-card>
          <v-card-title>
            <h3 class="headline font-weight-bold mb-0">Request for verification</h3>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="frmVerificationRequestValid" class="mt-0" @submit.prevent="">
              <v-select
                v-model="cboTemplateId"
                :rules="[v => !!v || 'Please choose a template']"
                :items="verificationTemplates"
                item-text="name"
                item-value="templateId"
                label="Template"
                @change="loadVerificationTemplate(cboTemplateId)"
                required
              ></v-select>
              <v-text-field
                v-model="txtVerificationSubject"
                :rules="[v => !!v || 'Subject is required']"
                label="Subject"
                required
              ></v-text-field>
              <wysiwyg :height=500 v-model="txtVerificationBodyHtml"/>
              <v-btn
                block
                color="primary"
                :disabled="!frmVerificationRequestValid"
                @click="requestForVerification()"
              >
                Send
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogViewVerification" @keydown.esc="dialogViewVerification = false" max-width="900px">
        <v-card>
          <v-card-title>
            <h3 class="headline font-weight-bold mb-0">{{ viewVerificationSubject }}</h3>
          </v-card-title>
          <v-card-text>
            <div style="width:100%;max-height:500px;border:1px solid #999999;" v-html="viewVerificationBodyHtml">
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAcceptOrder" max-width="290">
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>

          <v-card-text>
            Are you sure to accept this order?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="secondary"
              class="grey--text"
              @click="dialogAcceptOrder = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              @click="dialogAcceptOrder = false;"
            >
              Accept
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="similarOrdersDialog"
        max-width="1000"
      >
        <v-card class="pa-4">
          <h3 class="headline font-weight-bold">Similar Orders</h3>
          <div class="caption font-weight-regular mb-3">These orders having similar address with {{ salesOrderNo }}</div>
          <div style="max-height:500px;overflow-y:auto;border:1px solid #999999;">
            <v-container fluid grid-list-xs>
              <template v-if="similarOrders.length > 0">
                <v-layout row wrap v-for="(order, index) in similarOrders" :key="order.salesOrderNo">
                  <v-flex xs12 sm4>
                    <h4 class="subheading font-weight-bold mb-0">{{ order.salesOrderNo }}</h4>
                    {{ order.paymentMethodName }}
                    <br>
                    <v-btn
                      outline
                      small
                      class="ml-0 mt-4 mb-4"
                      :to="'/order/' + order.salesOrderNo"
                    >
                      View
                    </v-btn>
                  </v-flex>
                  <v-flex xs12 sm4 class="mb-4">
                    <strong>Billing adddress</strong>
                    <br>{{ order.billingTitle }} <span v-html="highlightKeywords(order.billingFirstName, highlightName)"></span> <span v-html="highlightKeywords(order.billingLastName, highlightName)"></span>
                    <span v-if="order.billingCompany"><br>{{ order.billingCompany }}</span>
                    <br><span v-html="highlightKeywords(order.billingAddress, highlightAddress)"></span>
                    <br>{{ order.billingCityName }}, {{ order.billingProvinceName }}
                    <br><span v-html="highlightKeywords(order.billingPostCode, highlightPostCode)"></span>, {{ order.billingCountryName }}
                    <span v-if="order.billingTaxId"><br>Tax ID{{ (billingTaxIdLocalName.length > 0 ? ' (' + billingTaxIdLocalName + ')' : '') }}: {{ order.billingTaxId }}</span>
                    <br><span v-html="highlightKeywords(order.billingPhone, highlightPhone)"></span>
                    <br>{{ order.billingEmail }}
                  </v-flex>
                  <v-flex xs12 sm4>
                    <strong>Shipping adddress</strong>
                    <br>{{ order.shippingTitle }} <span v-html="highlightKeywords(order.shippingFirstName, highlightName)"></span> <span v-html="highlightKeywords(order.shippingLastName, highlightName)"></span>
                    <span v-if="order.shippingCompany"><br>{{ order.shippingCompany }}</span>
                    <br><span v-html="highlightKeywords(order.shippingAddress, highlightAddress)"></span>
                    <br>{{ order.shippingCityName }}, {{ order.shippingProvinceName }}
                    <br><span v-html="highlightKeywords(order.shippingPostCode, highlightPostCode)"></span>, {{ order.shippingCountryName }}
                    <span v-if="order.shippingTaxId"><br>Tax ID{{ (shippingTaxIdLocalName.length > 0 ? ' (' + shippingTaxIdLocalName + ')' : '') }}: {{ order.shippingTaxId }}</span>
                    <br><span v-html="highlightKeywords(order.shippingPhone, highlightPhone)"></span>
                    <br>{{ order.shippingEmail }}
                  </v-flex>
                  <v-flex xs12 v-if="index < (similarOrders.length - 1)">
                    <v-divider class="mt-4 mb-4"></v-divider>
                  </v-flex>
                </v-layout>
              </template>
              <template v-else>
                <v-layout row wrap>
                  <v-flex
                    xs12
                    justify-center
                    align-center
                    text-xs-center
                  >
                    <v-icon x-large color="primary">error_outline</v-icon>
                    <div>
                      No similar order found
                    </div>
                  </v-flex>
                </v-layout>
              </template>
            </v-container>
          </div>
          <v-container fluid grid-list-lg class="pa-2">
            <v-layout row wrap>
              <v-flex sm6 hidden-xs-only>
              </v-flex>
              <v-flex sm3 xs6>
                <v-btn
                  block
                  outline
                  :disabled="similarOrderListOffset <= 0"
                  @click="getSimilarOrders('', (similarOrderListOffset-similarOrderListLimit <= 0 ? 0 : similarOrderListOffset-similarOrderListLimit))"
                >
                  Prev
                </v-btn>
              </v-flex>
              <v-flex sm3 xs6>
                <v-btn
                  block
                  outline
                  :disabled="similarOrderListOffset + similarOrderListLimit >= similarOrderListTotal"
                  @click="getSimilarOrders('', similarOrderListOffset+similarOrderListLimit)"
                >
                  Next
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAddIssue" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Add Issue</v-card-title>
          <v-layout align-center v-if="issueItem">
            <v-flex xs3 text-xs-center>
              <v-img v-if="issueItem.image" :src="issueItem.image" class="item-thumb ma-3"></v-img>
              <div v-else style="width:100%; height: 70px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
            </v-flex>
            <v-flex xs9 text-xs-left>
              <div class="font-weight-bold black--text"><a href="#">{{ issueItem.name }}</a></div>
              <div v-for="param in issueItem.itemParams" :key="param.name">
                <span class="font-weight-medium">{{ param.name }}: </span>
                <span v-if="param.value">{{ param.value }}</span>
                <div v-if="param.selections">
                  <div v-for="selection in param.selections" :key="selection.name">
                    {{ selection.name }} <span v-if="selection.priceInBase > 0">{{ currencySign + formatPrice(selection.priceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }}</span><span v-else-if="selection.price > 0">{{ currencySign + formatPrice(selection.price, currencyDecimals, currencyDecimalSign) }}</span>
                  </div>
                </div>
              </div>
              <div v-for="option in issueItem.options" :key="option.optionName">
                <span class="font-weight-medium">{{ option.optionName }}:</span> <span>{{ option.valueName }}</span>
              </div>
              <div class="caption mt-3"><strong>Prepared by:</strong>{{ issueItem.itemPreparedBy }}</div>
              <div class="caption"><strong>Seller has sent:</strong> {{ issueItem.incomingQty }} of {{ issueItem.qty }}</div>
            </v-flex>
          </v-layout>

          <v-card-text>
            <v-form ref="frmAddIssue" v-model="frmAddIssueValid" @submit.prevent="">
              <v-text-field
                v-model="txtIssueTitle"
                :rules="[v => !!v || 'Title is required']"
                label="Title"
                required
              ></v-text-field>
              <v-textarea
                v-model="txtIssueDetails"
                :rules="[v => !!v || 'Details is required']"
                label="Issue Details"
                auto-grow
                box
                required
              ></v-textarea>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmAddIssueValid"
                @click="addIssue"
              >
                Submit Issue
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogReplyIssue" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Reply Message</v-card-title>
          <v-card-text>
            <v-form ref="frmReplyIssue" v-model="frmReplyIssueValid" @submit.prevent="">
              <v-textarea
                v-model="txtReplyIssueMessage"
                :rules="[v => !!v || 'Message is required']"
                label="Reply Message"
                auto-grow
                box
                required
              ></v-textarea>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmReplyIssueValid"
                @click="replyIssue"
              >
                Add Update
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCloseIssue" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Close Issue</v-card-title>
          <v-card-text>
            <v-form ref="frmCloseIssue" v-model="frmCloseIssueValid">
              <v-textarea
                v-model="txtCloseIssueMessage"
                :rules="[v => !!v || 'Message is required']"
                label="Closing Message"
                auto-grow
                box
                required
              ></v-textarea>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmCloseIssueValid"
                @click="closeIssue"
              >
                Close Issue
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogReopenIssue" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Reopen Issue</v-card-title>
          <v-card-text>
            <v-form ref="frmReopenIssue" v-model="frmReopenIssueValid">
              <v-textarea
                v-model="txtReopenIssueMessage"
                :rules="[v => !!v || 'Message is required']"
                label="Reopen Message"
                auto-grow
                box
                required
              ></v-textarea>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmReopenIssueValid"
                @click="reopenIssue"
              >
                Reopen Issue
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="addVoucherDialog"
        max-width="400"
      >
        <v-card class="pa-4">
          <h3 class="headline font-weight-bold">Add Voucher</h3>
          <v-form ref="frmAddVoucher" v-model="frmAddVoucherValid">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Voucher Code"
                    v-model="txtVoucherCode"
                    :rules="[v => !!v || 'Voucher code is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    block
                    large
                    color="primary"
                    :disabled="!frmAddVoucherValid"
                    @click="addVoucher"
                  >
                    Add
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="deleteVoucherDialog"
        max-width="300"
      >
        <v-card>
          <v-card-title class="subheading font-weight-bold">Are you sure to remove this voucher?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              flat="flat"
              @click="deleteVoucherDialog = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="deleteVoucher(deleteVoucherIndex)"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>

      <v-dialog
        v-model="overrideProductCostPriceDialog"
        max-width="300"
      >
        <v-card>
          <v-card-title class="subheading font-weight-bold">Do you also want to update into product cost price ({{ overrideProductCostPriceItem.productCurrencySign + formatPrice(overrideProductCostPriceItem.productCostPrice, overrideProductCostPriceItem.productCurrencyDecimals, overrideProductCostPriceItem.productCurrencyDecimalSign) }})?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              flat="flat"
              @click="saveItemCostPrice(overrideProductCostPriceItem)"
            >
              Skip
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="saveItemCostPrice(overrideProductCostPriceItem, true)"
            >
              Override
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="addExtraCostDialog"
        max-width="400"
      >
        <v-card class="pa-4">
          <h3 class="headline font-weight-bold">Add Extra Cost</h3>
          <v-form ref="frmAddExtraCost" v-model="frmAddExtraCostValid">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Name"
                    v-model="txtExtraCostName"
                    :rules="[v => !!v || 'Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs5>
                  <v-select
                    v-model="cboExtraCostCurrencyCode"
                    v-bind:items="currencies"
                    item-text="sign"
                    item-value="currencyCode"
                    :rules="[v => !!v || 'Currency is required']"
                    required
                    @change="txtExtraCostExchangeRateToBase = getRateToBase(cboExtraCostCurrencyCode)"
                  ></v-select>
                </v-flex>
                <v-flex xs7>
                  <v-text-field
                    label="Amount"
                    v-model="txtExtraCostAmount"
                    :rules="[v => !!v || 'Amount is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="cboExtraCostCurrencyCode.length > 0 && cboExtraCostCurrencyCode !== def.currency.currencyCode">
                  <v-text-field
                    label="Rate to USD"
                    v-model="txtExtraCostExchangeRateToBase"
                    :rules="[v => !!v || 'Rate to USD is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    block
                    large
                    color="primary"
                    :disabled="!frmAddExtraCostValid"
                    @click="addExtraCost"
                  >
                    Add
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="editExtraCostDialog"
        max-width="400"
      >
        <v-card class="pa-4">
          <h3 class="headline font-weight-bold">Edit Extra Cost</h3>
          <v-form ref="frmEditExtraCost" v-model="frmEditExtraCostValid">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Name"
                    v-model="txtExtraCostName"
                    :rules="[v => !!v || 'Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs5>
                  <v-select
                    v-model="cboExtraCostCurrencyCode"
                    v-bind:items="currencies"
                    item-text="sign"
                    item-value="currencyCode"
                    :rules="[v => !!v || 'Currency is required']"
                    required
                    @change="txtExtraCostExchangeRateToBase = getRateToBase(cboExtraCostCurrencyCode)"
                  ></v-select>
                </v-flex>
                <v-flex xs7>
                  <v-text-field
                    label="Amount"
                    v-model="txtExtraCostAmount"
                    :rules="[v => !!v || 'Amount is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="cboExtraCostCurrencyCode.length > 0 && cboExtraCostCurrencyCode !== def.currency.currencyCode">
                  <v-text-field
                    label="Rate to USD"
                    v-model="txtExtraCostExchangeRateToBase"
                    :rules="[v => !!v || 'Rate to USD is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    block
                    large
                    color="primary"
                    :disabled="!frmEditExtraCostValid"
                    @click="editExtraCost"
                  >
                    Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="deleteExtraCostDialog"
        max-width="300"
      >
        <v-card>
          <v-card-title class="subheading font-weight-bold">Are you sure to remove this cost?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              flat="flat"
              @click="deleteExtraCostDialog = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="deleteExtraCost(deleteExtraCostIndex)"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>

    <div hidden="true">
      <div id='printMe' style="background-color: #f6f6f6; margin: 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; box-sizing: border-box; font-size: 14px;">
        <table style="background-color: #fff; border: 1px solid #e9e9e9; border-radius: 3px; margin: 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; box-sizing: border-box; font-size: 14px;" width="100%" cellpadding="0" cellspacing="0">
          <tr>
            <td style="padding: 0; text-align: center;">
              <table style="margin: 5px auto; text-align: left; width: 80%;">
                <tr>
                  <td align="center">
                    <img src="/static/img/logo-martview.jpg" style="width:100%; max-width:100px; margin-top: 20px;">
                  </td>
                </tr>
                <tr v-if="invoiceNo">
                  <td style="padding: 0 0 20px; text-align: left; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px;  line-height: 1.6em;">
                    <h1 style="text-align: center; font-size: 24px; font-family: 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif; color: #000; margin: 20px 0 0 0; line-height: 1.2em; font-weight: 400;">{{ invoiceNo }}</h1>
                    <h3 style="text-align: center; font-size: 12px; font-family: 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif; color: #000; margin: 0; line-height: 1.2em; font-weight: 400;">{{ salesOrderNo }}</h3>
                  </td>
                </tr>
                <tr v-else>
                  <td style="padding: 0 0 20px; text-align: left; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px;  line-height: 1.6em;">
                    <h1 style="text-align: center; font-size: 24px; font-family: 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif; color: #000; margin: 20px 0 0 0; line-height: 1.2em; font-weight: 400;">{{ salesOrderNo }}</h1>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 5px 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                    {{ createdDateTime | formatDate('DD MMMM YYYY', profile.gmtTimezone) }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 5px 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                    <strong>{{ shippingTitle }} {{ shippingFirstName }} {{ shippingLastName }}</strong>
                    <span v-if="shippingCompany"><br>{{ shippingCompany }}</span>
                    <br>{{ shippingAddress }}
                    <br>{{ shippingCityName }}, {{ shippingProvinceName }}
                    <br>{{ shippingPostCode }}, {{ shippingCountryName }}
                    <span v-if="shippingTaxId"><br>Tax ID{{ (shippingTaxIdLocalName.length > 0 ? ' (' + shippingTaxIdLocalName + ')' : '') }}: {{ shippingTaxId }}</span>
                    <br>{{ shippingPhone }}
                    <br>{{ shippingEmail }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 5px 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                    <strong>Remarks</strong>
                    <div v-html="(remarks ? remarks : '-')"></div>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 5px 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                    Payment Method: <strong>{{ paymentMethodName }}</strong>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 5px 0;">
                    <table style="width: 100%;" cellpadding="0" cellspacing="0">
                      <tr>
                        <td style="border-top: #eee 1px solid; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" colspan="4">
                        </td>
                      </tr>
                      <tr>
                        <td align="center" width="10%" style="padding: 5px 0; border-top: 2px solid #333; border-bottom: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                          SELLER
                        </td>
                        <td align="center" width="50%" style="padding: 5px 0; border-top: 2px solid #333; border-bottom: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                          ITEM
                        </td>
                        <td align="center" width="5%" style="padding: 5px 0; border-top: 2px solid #333; border-bottom: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                          QTY
                        </td>
                        <td align="center" width="15%" style="padding: 5px 0; border-top: 2px solid #333; border-bottom: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                          UNIT PRICE
                        </td>
                        <td align="center" width="20%" style="padding: 5px 0; border-top: 2px solid #333; border-bottom: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                          TOTAL PRICE
                        </td>
                      </tr>
                      <div v-for="(item, index) in orderItems" :key="index">
                        <tr>
                          <td valign="top" style="word-wrap: break-word; border-top: #eee 1px solid; padding-top: 15px; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 12px; line-height: 1.6em;">
                            {{ item.storeName | allCaps }}
                          </td>
                          <td style="border-top: #eee 1px solid; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 12px; line-height: 1.6em;">
                            <table style="width: 100%;" cellpadding="0" cellspacing="15">
                              <tr>
                                <td style="width: 60px;" valign="top">
                                  <img v-if="item.image" :src="item.image" style="width: 60px; height: auto;">
                                  <div v-else style="width:60px; height: 50px; border: 1px solid #333333; text-align: center; font-size: 11px; padding-top: 15px;">No Image</div>
                                </td>
                                <td style="width: 100%;">
                                  <strong>{{ item.name }}</strong>
                                  <div style="font-size:10px;">
                                    <div v-for="param in item.itemParams" :key="param.name">
                                      <strong>{{ param.name }}:</strong>
                                      <span v-if="param.value">{{ param.value }}</span>
                                      <div v-if="param.selections">
                                        <div v-for="selection in param.selections" :key="selection.name">
                                          {{ selection.name }} <span v-if="selection.priceInBase > 0">{{ currencySign + formatPrice(selection.priceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }}</span><span v-else-if="selection.price > 0">{{ currencySign + formatPrice(selection.price, currencyDecimals, currencyDecimalSign) }}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-for="option in item.options" :key="option.optionName">
                                      <strong>{{ option.optionName }}:</strong> <span>{{ option.valueName }}</span>
                                    </div>
                                    <div class="caption" v-if="item.shippingSubsidyAmount && item.shippingSubsidyAmount > 0">
                                      <span style="font-weight: 700;color: #376500">{{ currencySign }}{{ formatPrice(item.shippingSubsidyAmount, currencyDecimals, currencyDecimalSign) }} Free Shipping</span>
                                      with {{ item.shippingSubsidyCourierName }} {{ item.shippingSubsidyServiceName }}
                                    </div>
                                    <div v-if="item.qty === 0">
                                      <span style="color: #ff0000; font-weight: 700;">
                                        This item has been removed
                                      </span>
                                    </div>
                                    <div v-else-if="item.originalQty !== item.qty">
                                      <span style="color: #ff9900; font-weight: 700;">
                                        Qty has been modified from {{ item.originalQty }} to {{ item.qty }}
                                      </span>
                                    </div>
                                    <div v-else-if="item.isAdditionalItem === '1'">
                                      <span style="color: #ff9900; font-weight: 700;">
                                        Additional item
                                      </span>
                                    </div>
                                    <div v-if="item.itemPreparedBy" style="margin-top: 10px;">
                                      <div><strong>Prepared by:</strong> <span class="primary--text font-weight-bold">{{ item.itemPreparedBy }}</span></div>
                                      <div><strong>Status:</strong> <span>{{ item.deliveryStatus }}</span></div>
                                      <div><strong>Seller sent qty:</strong> <span>{{ item.incomingQty }} of {{ item.qty }}</span></div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td valign="top" style="padding: 15px 0; text-align: center; border-top: #eee 1px solid; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" width="15%">
                            {{ (item.qty > 0 ? item.qty : item.originalQty) }}
                          </td>
                          <td valign="top" style="padding: 15px 0; text-align: right; border-top: #eee 1px solid; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" width="15%">
                            {{ currencySign + formatPrice(item.unitPrice, currencyDecimals, currencyDecimalSign) }}
                          </td>
                          <td valign="top" style="padding: 15px 0; text-align: right; border-top: #eee 1px solid; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" width="15%">
                            {{ currencySign + formatPrice(item.totalPrice, currencyDecimals, currencyDecimalSign) }}
                          </td>
                        </tr>
                      </div>

                      <div>
                        <tr style="border-top: 2px solid #333; font-weight: 700;">
                          <td style="padding: 5px 0; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" colspan="2">
                            Subtotal
                          </td>
                          <td style="padding: 5px 0; text-align: right; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" colspan="3">
                            {{ currencySign + formatPrice(cacheTotalSales, currencyDecimals, currencyDecimalSign) }}
                          </td>
                        </tr>
                        <tr style="border-top: 2px solid #333; font-weight: 700;">
                          <td style="padding: 5px 0; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" colspan="2">
                            <strong>Shipping Cost</strong>
                            <table border=0 width="100%">
                              <tr v-for="(route, routeIndex) in routing" :key="routeIndex">
                                <td width="100%" style="font-size: 11px;">
                                  From {{ route.storeCityName }} ({{ formatPrice(route.shippingWeight) }}kg): {{ route.courierName}} {{ route.serviceCode}}) ({{ currencySign + formatPrice(route.deliveryCostBeforeSubsidy, currencyDecimals, currencyDecimalSign) }})
                                  <div style="font-weight: 700;color: #376500" v-if="route.shippingSubsidy > 0">
                                    - Free Shipping {{ currencySign + formatPrice(route.shippingSubsidy, currencyDecimals, currencyDecimalSign) }}
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td style="padding: 5px 0; text-align: right; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" colspan="3">
                            {{ currencySign + formatPrice(this.deliveryCost, this.currencyDecimals, this.currencyDecimalSign) }}
                          </td>
                        </tr>
                        <tr style="border-top: 2px solid #333; font-weight: 700;">
                          <td style="padding: 5px 0; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" colspan="2">
                            <strong>Import Duties</strong>
                            <table border=0 width="100%">
                              <tr v-for="(route, routeIndex) in routing" :key="routeIndex">
                                <td width="100%" style="font-size: 11px;">
                                  From {{ route.storeName }} - {{ route.storeCountryName }}: {{ currencySign + formatPrice(route.importTariff, currencyDecimals, currencyDecimalSign) }}
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td style="padding: 5px 0; text-align: right; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" colspan="3">
                            {{ currencySign + formatPrice(this.importTariff, this.currencyDecimals, this.currencyDecimalSign) }}
                          </td>
                        </tr>
                        <template v-if="vouchers && vouchers.length > 0">
                          <tr v-for="voucher in vouchers" :key="voucher.voucherCode" style="border-top: 2px solid #333; font-weight: 700;">
                            <td colspan=2 style="padding: 5px 0; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                              <strong>Voucher</strong>
                              <div style="font-weight:300;">{{ voucher.name + ' - ' + voucher.voucherCode }}</div>
                              <div v-if="voucher.valid !== '1'" style="font-size:10px;font-weight:300;color:red;">
                                {{ voucher.invalidReason }}
                              </div>
                            </td>
                            <td colspan=3 style="padding: 5px 0; text-align: right; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                              -{{ currencySign }}{{ formatPrice(voucher.discountAmountInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign) }}
                            </td>
                          </tr>
                        </template>
                        <tr style="border-top: 2px solid #333; font-weight: 700;">
                          <td style="padding: 5px 0; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" colspan="2">
                            Grand Total
                          </td>
                          <td style="padding: 5px 0; text-align: right; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" colspan="3">
                            {{ currencySign + formatPrice((this.cacheTotalSales + this.deliveryCost + this.importTariff) - this.cacheTotalVoucherDiscount, this.currencyDecimals, this.currencyDecimalSign) }}
                          </td>
                        </tr>
                      </div>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <v-dialog
      v-model="reviewImageDialog"
      max-width="600"
    >
      <v-card class="pa-4">
        <v-carousel v-if="review && review.reviewFiles && review.reviewFiles.length > 0" v-model="reviewImageCarousel" class="pa-0" style="border:1px solid #dedede;" height="auto" hide-delimiters show-arrows-on-hover>
          <v-carousel-item v-for="media in review.reviewFiles" :key="media.reviewFileId" style="min-height:500px;">
            <v-img :src="media.url" v-if="media.type === 'photo'" aspect-ratio="1" style="width:100%;height:100%;" />
            <video v-else width="100%" height="100%" controls>
              <source :src="media.videoUrl" :type="'video/' + media.extension">
              Your browser does not support the video player
            </video>
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="replyReviewDialog"
      max-width="600"
    >
      <v-card class="pa-4">
        <h2>Post a reply</h2>
        <v-form ref="form" v-model="frmReplyReviewValid" lazy-validation @submit.prevent="">
          <v-textarea
            v-model="txtReplyReview"
            :rules="[v => !!v || 'Reply is required', v => (v && v.length > 5) || 'Reply must be 5 characters or more']"
            label="Reply"
            required
          ></v-textarea>
          <v-btn
            :disabled="!frmReplyReviewValid"
            @click="replyReview()"
          >
            {{ (review.reviewReply !== '' ? 'Update' : 'Reply') }}
          </v-btn>
        </v-form>
      </v-card>
    </v-dialog>

    <map-view ref="mapView" :latitude="shippingLatitude" :longitude="shippingLongitude"></map-view>

  </div>
</template>

<style scoped>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";

.diagram td {
  text-align: center;
  padding: 5px;
}

.diagram-box {
  border: 1px solid #dedede;
}

table.v-table tbody td:first-child {
  padding: 15px 15px;
}

table.v-table tfoot td {
  padding: 15px 10px;
}

.cart-item-name {
  padding: 5px !important;
}

.cart-item-thumb {
  width: 100%;
  min-width: 60px;
  height: auto;
  border: 1px solid #dedede;
}

</style>

<script>
import downloadjs from 'downloadjs'
import SideDrawer from '@/components/SideDrawer.vue'
import MapView from '@/components/MapView.vue'
import axios from 'axios'
import router from '../router'
import UserNotesBox from '@/components/UserNotesBox.vue'
import Loading from '@/components/Loading.vue'
import { Timeline, TimelineItem, TimelineTitle } from 'vue-cute-timeline'

export default {
  props: [
    'salesOrderNo'
  ],
  components: {
    SideDrawer,
    MapView,
    UserNotesBox,
    Loading,
    Timeline,
    TimelineItem,
    TimelineTitle
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      dialogAcceptOrder: false,
      menuItems: [
        { title: 'Print' }
      ],
      shipmentDialogHeaders: [
        {
          text: 'Item Name',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Qty', value: 'qty', align: 'right', sortable: false }
      ],
      dialogAddIssue: false,
      frmAddIssueValid: false,
      issueItem: null,
      txtIssueTitle: '',
      txtIssueDetails: '',
      dialogReplyIssue: false,
      frmReplyIssueValid: false,
      txtIssueTicketId: '',
      txtReplyIssueMessage: '',
      dialogCloseIssue: false,
      frmCloseIssueValid: false,
      txtCloseIssueMessage: '',
      dialogReopenIssue: false,
      frmReopenIssueValid: false,
      txtReopenIssueMessage: '',
      invoiceNo: '',
      invoiceNos: [],
      createdDateTime: '',
      createdByAdminId: '',
      createdByAdminName: '',
      expiryDateTime: '',
      userId: '',
      remarks: '',
      isChargebackUser: '0',
      userChargebackDateTime: '',
      loginEmail: '',
      billingTitle: '',
      billingFirstName: '',
      billingLastName: '',
      billingCompany: '',
      billingAddress: '',
      billingPostCode: '',
      billingCityId: '',
      billingCityName: '',
      billingProvinceId: '',
      billingProvinceName: '',
      billingCountryId: '',
      billingCountryName: '',
      billingPhone: '',
      billingTaxId: '',
      billingTaxIdLocalName: '',
      billingEmail: '',
      shippingTitle: '',
      shippingFirstName: '',
      shippingLastName: '',
      shippingCompany: '',
      shippingAddress: '',
      shippingPostCode: '',
      shippingCityId: '',
      shippingCityName: '',
      shippingProvinceId: '',
      shippingProvinceName: '',
      shippingCountryId: '',
      shippingCountryName: '',
      shippingPhone: '',
      shippingTaxId: '',
      shippingTaxIdLocalName: '',
      shippingEmail: '',
      shippingLatitude: 0,
      shippingLongitude: 0,
      cacheTotalWeight: '',
      orderType: '',
      paymentStatus: '',
      paymentStatusIcon: '',
      paymentStatusColor: 'grey darken-2',
      payments: [],
      paymentDiscounts: [],
      paymentMethodName: '',
      paidDateTime: '',
      deliveryStatus: '',
      deliveryStatusIcon: '',
      deliveryStatusColor: 'grey darken-2',
      declareValuePercentage: 0,
      customerSelectedCourierId: '',
      customerSelectedServiceCode: '',
      salesOrderDeliveredDO: [],
      exchangeRateToBase: 1,
      currencies: [],
      currencyCode: '',
      currencySign: '',
      currencyDecimals: 0,
      currencyDecimalSign: '',
      deliveryCost: '',
      importTariff: '',
      cacheTotalSales: '',
      isCostPriceChange: false,
      orderItems: [],
      footers: [],
      routing: [],
      events: [],
      userNotes: [],
      vouchers: [],
      review: {},
      dialogShipment: false,
      frmShipmentValid: false,
      frmNotesValid: false,
      txtNotes: '',
      switchNoteSellerVisible: false,
      noteFileUploads: [],
      cboCourier: null,
      cboService: null,
      txtTrackingNo: '',
      bankAccounts: [],
      companyInfo: null,
      couriers: [],
      courierServices: [],
      verificationTemplates: [],
      dialogVerificationRequest: false,
      frmVerificationRequestValid: false,
      cboTemplateId: '',
      txtVerificationSubject: '',
      txtVerificationBodyHtml: '',
      verifications: [],
      dialogViewVerification: false,
      viewVerificationSubject: '',
      viewVerificationBodyHtml: '',
      similarOrdersDialog: false,
      highlightName: '',
      highlightAddress: '',
      highlightPhone: '',
      highlightPostCode: '',
      similarOrders: [],
      similarOrderListLimit: 10,
      similarOrderListOffset: 0,
      similarOrderListTotal: 0,
      addVoucherDialog: false,
      frmAddVoucherValid: false,
      txtVoucherCode: '',
      deleteVoucherDialog: false,
      deleteVoucherIndex: '',
      cacheTotalVoucherDiscount: 0,
      overrideProductCostPriceDialog: false,
      overrideProductCostPriceItem: {},
      addExtraCostDialog: false,
      frmAddExtraCostValid: false,
      txtExtraCostName: '',
      cboExtraCostCurrencyCode: '',
      txtExtraCostExchangeRateToBase: 1,
      txtExtraCostAmount: '',
      editExtraCostDialog: false,
      frmEditExtraCostValid: false,
      editExtraCostIndex: '',
      deleteExtraCostDialog: false,
      deleteExtraCostIndex: '',
      sellers: [],
      cacheBranchSalesInBase: 0,
      cacheBranchCostInBase: 0,
      cacheCostPriceInBaseFundedByHQ: 0,
      cacheBranchCostPriceStatus: '',
      cacheBranchShippingCostInBase: 0,
      cacheBranchRealShippingCostInBase: 0,
      cacheBranchRealShippingCostStatus: '',
      cacheSellerFeeInBase: 0,
      cachePaymentFeeReceivedInBase: 0,
      cachePaymentRealFeeInBase: 0,
      cachePaymentRealFeeStatus: '',
      cachePaymentCommissionInBase: 0,
      cachePaymentCommissionStatus: '',
      cacheExtraCostInBase: 0,
      cacheProfitInBase: 0,
      cacheProfitStatus: '',
      extraCosts: [],
      isAccessCosting: false,
      isAccessTransaction: false,
      bulkCostEditingDialog: false,
      bulkCostEditingValid: false,
      bulkCostEditingItems: [],
      chkBulkCostItems: false,
      bulkCostEditingCopyRateDialog: false,
      bulkCostEditingCopyRateCurrencyCode: '',
      bulkCostEditingCopyRate: 0,
      reviewImageCarousel: 0,
      reviewImageDialog: false,
      replyReviewDialog: false,
      frmReplyReviewValid: false,
      txtReplyReview: ''
    }
  },
  computed: {
    deliveryButtonCaption: function () {
      if (this.deliveryStatus === 'pending' || this.deliveryStatus === 'partial') {
        return 'Ship'
      } else {
        return 'View'
      }
    },
    confirmDeliveryButtonCaption: function () {
      if (this.deliveryStatus === 'pending' || this.deliveryStatus === 'partial') {
        return 'SHIP ORDER'
      } else {
        return 'VIEW SHIPMENT'
      }
    }
  },
  mounted () {
    this.openDrawerForDesktop()
    this.getSalesOrderDetails()
    this.getCurrencies()
    this.getTemplates()

    if (typeof this.profile.permissions !== 'undefined') {
      for (var i in this.profile.permissions) {
        if (this.profile.permissions[i].permissionId === 'PEM-COSTING' && this.profile.permissions[i].isRead === '1') {
          this.isAccessCosting = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-TRANSACTION' && this.profile.permissions[i].isRead === '1') {
          this.isAccessTransaction = true
        }
      }
    }
  },

  watch: {
    cboCourier (newValue, oldValue) {
      for (var c = 0; c < this.couriers.length; ++c) {
        if (this.couriers[c].courierId === newValue) {
          this.courierServices = this.couriers[c].rates
          break
        }
      }
    }
  },

  methods: {
    showReplyReviewDialog () {
      this.frmReplyReviewValid = false
      this.txtReplyReview = this.review.reviewReply
      this.replyReviewDialog = true
    },
    replyReview () {
      let _this = this
      _this.loading = true
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo + '/review/reply', { reply: _this.txtReplyReview }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            _this.loading = false
            _this.getSalesOrderDetails()
            _this.replyReviewDialog = false
          } else {
            _this.loading = false
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              _this.$store.dispatch('AUTH_LOGOUT')
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
          }
        })
    },
    showReviewImageDialog (index) {
      this.reviewImageCarousel = index
      this.reviewImageDialog = true
    },
    showMapView: function () {
      this.$refs.mapView.showMap()
    },
    requestReview () {
      let _this = this
      _this.loading = true
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo + '/review/request', null, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            _this.loading = false
            _this.getSalesOrderDetails()
          } else {
            _this.loading = false
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              _this.$store.dispatch('AUTH_LOGOUT')
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
          }
        })
    },
    selectAllCostingCheckboxes: function (chkStatus) {
      for (let i in this.orderItems) {
        if ((this.orderItems[i].storeType === 'branch' || this.orderItems[i].isPricingManagedByMV === '1') && this.orderItems[i].qty > 0) {
          this.orderItems[i].chkCostPrice = chkStatus
        }
      }
    },
    showBulkCostEditingCopyRateConfirmation: function (itemIndex) {
      this.bulkCostEditingCopyRateCurrencyCode = this.bulkCostEditingItems[itemIndex].costPriceCurrencyCode
      this.bulkCostEditingCopyRate = this.bulkCostEditingItems[itemIndex].costPriceExchangeRateToBase
      this.bulkCostEditingCopyRateDialog = true
    },
    bulkCostEditingCopyRateToAll: function (currencyCode, rate) {
      for (let i in this.bulkCostEditingItems) {
        if (this.bulkCostEditingItems[i].isSkipCostPrice === 0 || this.bulkCostEditingItems[i].isSkipCostPrice === false) {
          if (this.bulkCostEditingItems[i].costPriceCurrencyCode === currencyCode) {
            this.bulkCostEditingItems[i].costPriceExchangeRateToBase = rate
          }
        }
      }
      this.bulkCostEditingCopyRateDialog = false
    },
    showBulkCostEditingDialog: function () {
      this.bulkCostEditingItems = []
      this.bulkCostEditingValid = true
      let isValid = false
      for (let i in this.orderItems) {
        if (this.orderItems[i].chkCostPrice === true && this.orderItems[i].qty > 0) {
          let tmp = this.orderItems[i]
          tmp.cboCurrencyRules = this.generateCboCurrencyRules(this.orderItems[i].isSkipCostPrice)
          tmp.txtCostPriceRules = this.generateTxtCostPriceRules(this.orderItems[i].isSkipCostPrice)

          this.bulkCostEditingItems.push(this.deepCopy(tmp))
          isValid = true
        }
      }

      if (isValid) {
        this.$refs.frmBulkCostEditing.validate()
        this.bulkCostEditingDialog = true
      } else {
        window.alert('Please select item')
      }
    },
    updateBulkCostingFieldRules: function (itemIndex) {
      this.bulkCostEditingItems[itemIndex].cboCurrencyRules = this.generateCboCurrencyRules(this.bulkCostEditingItems[itemIndex].isSkipCostPrice)
      this.bulkCostEditingItems[itemIndex].txtCostPriceRules = this.generateTxtCostPriceRules(this.bulkCostEditingItems[itemIndex].isSkipCostPrice)
    },
    generateCboCurrencyRules: function (isSkipCosting) {
      if (isSkipCosting === '1' || isSkipCosting === 1 || isSkipCosting === true) {
        return []
      }
      return [v => !!v || 'Currency is required']
    },
    generateTxtCostPriceRules: function (isSkipCosting) {
      if (isSkipCosting === '1' || isSkipCosting === 1 || isSkipCosting === true) {
        return []
      }
      return [v => !!v || 'Cost is required', v => (v >= 0) || 'Invalid cost']
    },
    deleteBulkCostItem: function (itemIndex) {
      this.bulkCostEditingItems.splice(itemIndex, 1)
    },
    saveBulkCostItem () {
      var _this = this
      _this.loading = false
      let items = []
      for (let i in _this.bulkCostEditingItems) {
        items.push({
          sku: _this.bulkCostEditingItems[i].sku,
          paramHash: _this.bulkCostEditingItems[i].paramHash,
          isSkipCostPrice: _this.bulkCostEditingItems[i].isSkipCostPrice,
          currencyCode: _this.bulkCostEditingItems[i].costPriceCurrencyCode,
          exchangeRateToBase: _this.bulkCostEditingItems[i].costPriceExchangeRateToBase,
          costPrice: _this.bulkCostEditingItems[i].costPrice,
          amountFundedByHQ: _this.bulkCostEditingItems[i].costPriceFundedByHQ,
          isOverrideToProduct: false
        })
      }
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/costing/sales/' + this.salesOrderNo + '/products', {
        items: items
      })
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.getSalesOrderDetails()
            _this.bulkCostEditingDialog = false
            _this.chkBulkCostItems = false
          } else {
            window.alert('Unable to save: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            _this.loading = false
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
          }
        })
    },
    isEnableSaveCostButton: function (item) {
      if (item.costPriceCurrencyCode !== '' && item.costPrice > 0 && item.costPriceExchangeRateToBase > 0) {
        return true
      } else if (item.isSkipCostPrice) {
        return true
      } else if (item.saveButtonStatus === 'disabled') {
        return false
      }
      return false
    },
    getCostStatusColor: function (status) {
      if (status === 'pending') {
        return 'grey--text text--darken-1'
      } else if (status === 'partial') {
        return 'orange--text text--lighten-1'
      } else if (status === 'complete' || status === 'sent') {
        return 'green--text text--lighten-1'
      }
      return false
    },
    getRateToBase: function (currencyCode) {
      for (var i in this.currencies) {
        if (this.currencies[i].currencyCode === currencyCode) {
          return this.currencies[i].exchangeRateToBase
        }
      }
      return 0
    },
    getCurrencies: function () {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'success') {
            for (var i in resp.data.data) {
              if (resp.data.data[i].currencyCode === this.currencyCode) {
                resp.data.data[i].exchangeRateToBase = this.exchangeRateToBase
              }
            }
            this.currencies = resp.data.data
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    showOverrideProductCostPriceDialog: function (item) {
      // if (item.productCostPrice > 0 && Math.abs((item.costPrice * item.costPriceExchangeRateToBase) - (item.productCostPrice * item.productCurrencyExchangeRateToBase)) > 0.1) {
      //   this.overrideProductCostPriceItem = item
      //   this.overrideProductCostPriceDialog = true
      // } else {
      this.saveItemCostPrice(item)
      // }
    },
    showAddExtraCostDialog: function () {
      this.txtExtraCostName = ''
      this.cboExtraCostCurrencyCode = ''
      this.txtExtraCostExchangeRateToBase = 1
      this.txtExtraCostAmount = ''
      this.addExtraCostDialog = true
    },
    showDeleteExtraCostDialog: function (extraCostIndex) {
      this.deleteExtraCostIndex = extraCostIndex
      this.deleteExtraCostDialog = true
    },
    showEditExtraCostDialog: function (extraCostIndex) {
      this.editExtraCostIndex = extraCostIndex
      this.txtExtraCostName = this.extraCosts[extraCostIndex].name
      this.cboExtraCostCurrencyCode = this.extraCosts[extraCostIndex].currencyCode
      this.txtExtraCostExchangeRateToBase = this.extraCosts[extraCostIndex].exchangeRateToBase
      this.txtExtraCostAmount = this.extraCosts[extraCostIndex].amount
      this.editExtraCostDialog = true
    },
    addExtraCost () {
      var _this = this
      if (_this.$refs.frmAddExtraCost.validate()) {
        _this.loading = true
        var data = {
          salesOrderNo: _this.salesOrderNo,
          name: _this.txtExtraCostName,
          currencyCode: _this.cboExtraCostCurrencyCode,
          exchangeRateToBase: _this.txtExtraCostExchangeRateToBase,
          amount: _this.txtExtraCostAmount
        }

        axios.post(process.env.VUE_APP_API_ROOT + '/v1/costing/sales/extra', data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.loading = false
              _this.getSalesOrderDetails()
              _this.addExtraCostDialog = false
            } else {
              _this.loading = false
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                _this.$store.dispatch('AUTH_LOGOUT')
                router.push('/login?next=' + _this.$route.fullPath)
              }
              _this.loading = false
            }
          })
      }
    },
    editExtraCost () {
      var _this = this
      if (_this.$refs.frmEditExtraCost.validate()) {
        _this.loading = true
        var data = {
          salesOrderNo: _this.salesOrderNo,
          name: _this.txtExtraCostName,
          currencyCode: _this.cboExtraCostCurrencyCode,
          exchangeRateToBase: _this.txtExtraCostExchangeRateToBase,
          amount: _this.txtExtraCostAmount
        }

        axios.put(process.env.VUE_APP_API_ROOT + '/v1/costing/sales/extra/' + _this.extraCosts[_this.editExtraCostIndex].costId, data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.loading = false
              _this.getSalesOrderDetails()
              _this.editExtraCostDialog = false
            } else {
              _this.loading = false
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                _this.$store.dispatch('AUTH_LOGOUT')
                router.push('/login?next=' + _this.$route.fullPath)
              }
              _this.loading = false
            }
          })
      }
    },
    deleteExtraCost (extraCostIndex) {
      var _this = this
      _this.loading = true
      if (typeof _this.extraCosts[extraCostIndex].costId !== 'undefined') {
        axios.delete(process.env.VUE_APP_API_ROOT + '/v1/costing/sales/extra/' + _this.extraCosts[extraCostIndex].costId)
          .then(resp => {
            console.log(resp.data)
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.getSalesOrderDetails()
              _this.deleteExtraCostDialog = false
            } else {
              window.alert('unable to remove cost: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                _this.$store.dispatch('AUTH_LOGOUT')
                router.push('/login?next=' + this.$route.fullPath)
              }
              _this.loading = false
            }
          })
      } else {
        window.alert('Invalid cost to delete')
      }
    },
    saveItemCostPrice (item, isOverrideToProduct = false) {
      var _this = this
      item.saveButtonStatus = 'saving'
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/costing/sales/' + this.salesOrderNo + '/products', {
        items: [
          {
            sku: item.sku,
            paramHash: item.paramHash,
            isSkipCostPrice: item.isSkipCostPrice,
            currencyCode: item.costPriceCurrencyCode,
            exchangeRateToBase: item.costPriceExchangeRateToBase,
            costPrice: item.costPrice,
            amountFundedByHQ: item.costPriceFundedByHQ,
            isOverrideToProduct: isOverrideToProduct
          }
        ]
      })
        .then(resp => {
          if (resp.data.status === 'success') {
            item.saveButtonStatus = 'success'
            _this.getSalesOrderDetails()
            setTimeout(function () {
              item.saveButtonStatus = 'disabled'
            }, (5 * 1000))
            _this.overrideProductCostPriceDialog = false
          } else {
            item.saveButtonStatus = ''
            window.alert('Unable to save item cost price: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            item.saveButtonStatus = ''
          }
        })
    },
    saveCostPrice () {
      // if (this.$refs.frmReplyIssue.validate()) {
      this.loading = true
      var items = []
      for (var i in this.orderItems) {
        if (this.orderItems[i].costPrice.length >= 0 && Number(this.orderItems[i].costPrice) > 0 && this.orderItems[i].costPriceCurrencyCode.length >= 0) {
          items.push({
            sku: this.orderItems[i].sku,
            paramHash: this.orderItems[i].paramHash,
            isSkipCostPrice: this.orderItems[i].isSkipCostPrice,
            currencyCode: this.orderItems[i].costPriceCurrencyCode,
            exchangeRateToBase: this.orderItems[i].costPriceExchangeRateToBase,
            costPrice: this.orderItems[i].costPrice
          })
        } else {
          items.push({
            sku: this.orderItems[i].sku,
            paramHash: this.orderItems[i].paramHash,
            isSkipCostPrice: false,
            currencyCode: null,
            exchangeRateToBase: null,
            costPrice: null
          })
        }
      }
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/costing/sales/' + this.salesOrderNo + '/products', {
        items: items
      })
        .then(resp => {
          this.loading = false
          if (resp.data.status === 'success') {
            window.alert('Cost price saved')
            this.refreshOrder()
          } else {
            window.alert('Unable to save cost price: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            }
            this.loading = false
          }
        })
      // }
    },
    showAddVoucherDialog: function () {
      this.txtVoucherCode = ''
      this.addVoucherDialog = true
    },
    showDeleteVoucherDialog: function (voucherIndex) {
      this.deleteVoucherIndex = voucherIndex
      this.deleteVoucherDialog = true
    },
    addVoucher () {
      var _this = this
      if (_this.$refs.frmAddVoucher.validate()) {
        _this.loading = true
        var data = {
          voucherCodes: [_this.txtVoucherCode]
        }

        axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo + '/voucher', data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.loading = false
              _this.getSalesOrderDetails()
              _this.addVoucherDialog = false
            } else {
              _this.loading = false
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                _this.$store.dispatch('AUTH_LOGOUT')
                router.push('/login?next=' + _this.$route.fullPath)
              }
              _this.loading = false
            }
          })
      }
    },
    deleteVoucher (voucherIndex) {
      var _this = this
      _this.loading = true
      if (typeof _this.vouchers[voucherIndex].voucherCode !== 'undefined') {
        axios.delete(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo + '/voucher/' + _this.vouchers[voucherIndex].voucherCode)
          .then(resp => {
            console.log(resp.data)
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.getSalesOrderDetails()
              _this.deleteVoucherDialog = false
            } else {
              window.alert('unable to remove voucher: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                _this.$store.dispatch('AUTH_LOGOUT')
                router.push('/login?next=' + this.$route.fullPath)
              }
              _this.loading = false
            }
          })
      } else {
        window.alert('Invalid voucher to delete')
      }
    },
    pickFile: function () {
      this.$refs.filePicker.click()
    },
    onFilePicked: function (e) {
      const files = e.target.files
      console.log(files)

      if (files.length + this.noteFileUploads.length > 3) {
        window.alert('You can only upload maximum of 3 files')
        return false
      }

      for (let i = 0; i < files.length; i++) {
        if (typeof files[i] === 'object') {
          if (files[i].name.lastIndexOf('.') <= 0) {
            return
          }

          const fr = new FileReader()
          fr.readAsDataURL(files[i])
          var _this = this
          fr.addEventListener('load', () => {
            _this.noteFileUploads.push({
              name: files[i].name,
              url: fr.result,
              file: files[i]
            })
          })
        }
      }
    },
    removeFileUpload: function (fileIndex) {
      this.noteFileUploads.splice(fileIndex, 1)
    },
    showReopenIssueDialog: function (ticketId) {
      this.txtIssueTicketId = ticketId
      this.txtReopenIssueMessage = ''
      this.frmReopenIssueValid = false
      this.dialogReopenIssue = true
    },
    reopenIssue () {
      if (this.$refs.frmReopenIssue.validate()) {
        this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + this.txtIssueTicketId + '/reply', {
          message: this.txtReopenIssueMessage
        })
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              this.dialogReopenIssue = false
              this.getSalesOrderDetails()
            } else {
              window.alert('Unable to reopen issue: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              }
              this.loading = false
            }
          })
      }
    },
    showCloseIssueDialog: function (ticketId) {
      this.txtIssueTicketId = ticketId
      this.txtCloseIssueMessage = ''
      this.frmCloseIssueValid = false
      this.dialogCloseIssue = true
    },
    closeIssue () {
      if (this.$refs.frmCloseIssue.validate()) {
        this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + this.txtIssueTicketId + '/close', {
          message: this.txtCloseIssueMessage
        })
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              this.dialogCloseIssue = false
              this.getSalesOrderDetails()
            } else {
              window.alert('Unable to close issue: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              }
              this.loading = false
            }
          })
      }
    },
    showReplyIssueDialog: function (ticketId) {
      this.txtIssueTicketId = ticketId
      this.txtReplyIssueMessage = ''
      this.frmReplyIssueValid = false
      this.dialogReplyIssue = true
    },
    replyIssue () {
      if (this.$refs.frmReplyIssue.validate()) {
        this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + this.txtIssueTicketId + '/reply', {
          message: this.txtReplyIssueMessage
        })
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              this.dialogReplyIssue = false
              this.getSalesOrderDetails()
            } else {
              window.alert('Unable to reply issue: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              }
              this.loading = false
            }
          })
      }
    },
    showAddIssueDialog: function (issueItem) {
      this.issueItem = issueItem
      this.txtIssueTitle = ''
      this.txtIssueDetails = ''
      this.frmAddIssueValid = false
      this.dialogAddIssue = true
    },
    addIssue () {
      if (this.$refs.frmAddIssue.validate()) {
        this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/sales/item/issue', {
          salesOrderNo: this.issueItem.salesOrderNo,
          sku: this.issueItem.sku,
          paramHash: this.issueItem.paramHash,
          title: this.txtIssueTitle,
          message: this.txtIssueDetails
        })
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              this.dialogAddIssue = false
              this.getSalesOrderDetails()
            } else {
              window.alert('Unable to add issue: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              }
              this.loading = false
            }
          })
      }
    },
    showSimilarOrders: function () {
      this.similarOrders = []
      this.similarOrderListOffset = 0
      this.similarOrderListTotal = 0
      this.getSimilarOrders()
      this.similarOrdersDialog = true
    },
    getSimilarOrders: function (sort = 'desc', offset = 0, limit = 10) {
      this.loading = true
      let _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales/' + this.salesOrderNo + '/similar?sort=createdDateTime%3A' + sort + '&offset=' + offset + '&limit=' + limit)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.similarOrders = _this.similarOrders.concat(resp.data.data)
            _this.similarOrderListLimit = resp.data.limit
            _this.similarOrderListOffset = resp.data.offset
            _this.similarOrderListTotal = resp.data.total
          } else {
            console.log('unable to load similar order list: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    addNotes (notes, isSellerVisible) {
      var _this = this
      if (_this.$refs.frmNotes.validate()) {
        _this.loading = true

        // inject files
        var i, j
        var isUploadFile = false
        var formData = new FormData()
        for (i in _this.noteFileUploads) {
          if (typeof _this.noteFileUploads[i].uploadStatus === 'undefined' || _this.noteFileUploads[i].uploadStatus !== 'success') {
            formData.append('file' + (parseInt(i) + 1), _this.noteFileUploads[i].file, _this.noteFileUploads[i].name)
            _this.noteFileUploads[i].uploadStatus = 'uploading'
            isUploadFile = true
          }
        }

        if (isUploadFile) {
          // upload files
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales/note/file', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(resp => {
              console.log(resp.data)
              if (resp.data.status === 'success') {
                var errorCount = 0
                for (i = 1; i <= 3; i++) {
                  if (typeof resp.data.data['file' + i] !== 'undefined' && typeof resp.data.data['file' + i].noteFileId !== 'undefined') {
                    for (j in _this.noteFileUploads) {
                      if (resp.data.data['file' + i].fileName === _this.noteFileUploads[j].name) {
                        if (typeof resp.data.data['file' + i].noteFileId !== 'undefined') {
                          _this.noteFileUploads[j].noteFileId = resp.data.data['file' + i].noteFileId
                          _this.noteFileUploads[j].uploadStatus = 'success'
                        } else {
                          _this.noteFileUploads[j].uploadStatus = 'error'
                          errorCount++
                        }
                        break
                      }
                    }
                  }
                }

                // only continue if all upload success
                if (errorCount === 0) {
                  _this.submitNotes(notes, isSellerVisible, _this.noteFileUploads)
                } else {
                  window.alert(errorCount + ' of the file upload failed, please retry')
                }
              } else {
                window.alert(resp.data.message)
              }
              _this.loading = false
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                }
                _this.loading = false
              }
            })
        } else {
          _this.submitNotes(notes, isSellerVisible, _this.noteFileUploads)
        }
      }
    },
    submitNotes (notes, isSellerVisible, files = []) {
      var _this = this
      _this.loading = true

      var submitData = {
        notes: notes,
        isSellerVisible: isSellerVisible
      }

      // inject files
      if (files.length > 0) {
        var fileIds = []
        for (var i in files) {
          fileIds.push(files[i].noteFileId)
        }
        submitData.fileIds = fileIds
      }

      axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo + '/note', submitData)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.txtNotes = ''
            _this.switchNoteSellerVisible = false
            _this.noteFileUploads = []
            _this.getSalesOrderDetails()
          } else {
            window.alert('unable to add note: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
          }
        })
    },
    generateShippingQtyDropdown: function (qty, unit) {
      var result = []
      for (var i = qty; i >= 0; i--) {
        result.push(
          {
            caption: i + ' ' + unit,
            value: i
          })
      }
      return result
    },
    viewVerificationRequest: function (verificationId) {
      var isFound = false
      for (var i in this.verifications) {
        if (this.verifications[i].verificationId === verificationId) {
          this.viewVerificationSubject = this.verifications[i].subject
          this.viewVerificationBodyHtml = this.verifications[i].bodyHtml
          isFound = true
          this.dialogViewVerification = true
          break
        }
      }

      if (!isFound) {
        window.alert('Invalid verification Id')
      }
    },
    loadVerificationTemplate: function (templateId) {
      for (var i in this.verificationTemplates) {
        if (this.verificationTemplates[i].templateId === templateId) {
          this.txtVerificationSubject = this.verificationTemplates[i].subject
          this.txtVerificationBodyHtml = this.verificationTemplates[i].bodyHtml
          break
        }
      }
    },
    clickMenu: function (menuTitle) {
      switch (menuTitle) {
        case 'Print':
          var url = process.env.VUE_APP_API_ROOT + '/v1/payment/methods'

          this.loading = true
          axios.get(url)
            .then(resp => {
              this.loading = false
              if (resp.data.status === 'success') {
                for (var c = 0; c < resp.data.data.length; ++c) {
                  if (resp.data.data[c].paymentMethodId.substr(0, 12) === 'BANKTRANSFER') {
                    this.bankAccounts = resp.data.data[c].bankAccounts
                    break
                  }
                }
                setTimeout(function () {
                  var divToPrint = document.getElementById('printMe')
                  var newWin = window.open('')
                  newWin.document.write(divToPrint.outerHTML)
                  newWin.document.close()

                  newWin.onload = function () { // wait until all resources loaded
                    newWin.focus() // necessary for IE >= 10
                    newWin.print() // change window to mywindow
                    newWin.close() // change window to mywindow
                  }
                }, 250)
              } else {
                console.log('unable to getPaymentMethods: ' + resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log('getPaymentMethods : ' + error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                }
                this.loading = false
              }
            })
          break
      }
    },
    getTemplates: function () {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales/' + this.salesOrderNo + '/verification/templates')
        .then(resp => {
          this.loading = false
          if (resp.data.status === 'success') {
            this.verificationTemplates = resp.data.data
          } else {
            console.log('unable to get templates: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log('failed to get templates: ' + error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            }
            this.loading = false
          }
        })
    },
    getSalesOrderDetails: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo)
        .then(resp => {
          this.loading = false
          if (resp.data.status === 'success') {
            this.userId = resp.data.data.userId
            if (this.salesOrderNo !== resp.data.data.salesOrderNo) {
              this.salesOrderNo = resp.data.data.salesOrderNo
            }
            this.invoiceNo = resp.data.data.invoiceNo
            if (typeof resp.data.data.invoiceNos === 'object') {
              this.invoiceNos = resp.data.data.invoiceNos
            }
            this.createdDateTime = resp.data.data.createdDateTime
            this.createdByAdminId = resp.data.data.createdByAdminId
            this.createdByAdminName = resp.data.data.createdByAdminName
            this.expiryDateTime = resp.data.data.expiryDateTime
            this.remarks = resp.data.data.remarks
            this.isChargebackUser = resp.data.data.isChargebackUser
            this.userChargebackDateTime = resp.data.data.userChargebackDateTime
            this.loginEmail = resp.data.data.loginEmail
            this.billingTitle = resp.data.data.billingTitle
            this.billingFirstName = resp.data.data.billingFirstName
            this.billingLastName = resp.data.data.billingLastName
            this.billingCompany = resp.data.data.billingCompany
            this.billingPhone = resp.data.data.billingPhone
            this.billingAddress = resp.data.data.billingAddress
            this.billingPostCode = resp.data.data.billingPostCode
            this.billingCityId = resp.data.data.billingCityId
            this.billingCityName = resp.data.data.billingCityName
            this.billingProvinceId = resp.data.data.billingProvinceId
            this.billingProvinceName = resp.data.data.billingProvinceName
            this.billingCountryId = resp.data.data.billingCountryId
            this.billingCountryName = resp.data.data.billingCountryName
            this.billingTaxId = resp.data.data.billingTaxId
            this.billingTaxIdLocalName = resp.data.data.billingTaxIdLocalName
            this.billingEmail = resp.data.data.loginEmail
            this.shippingTitle = resp.data.data.shippingTitle
            this.shippingFirstName = resp.data.data.shippingFirstName
            this.shippingLastName = resp.data.data.shippingLastName
            this.shippingCompany = resp.data.data.shippingCompany
            this.shippingPhone = resp.data.data.shippingPhone
            this.shippingAddress = resp.data.data.shippingAddress
            this.shippingPostCode = resp.data.data.shippingPostCode
            this.shippingCityId = resp.data.data.shippingCityId
            this.shippingCityName = resp.data.data.shippingCityName
            this.shippingProvinceId = resp.data.data.shippingProvinceId
            this.shippingProvinceName = resp.data.data.shippingProvinceName
            this.shippingCountryId = resp.data.data.shippingCountryId
            this.shippingCountryName = resp.data.data.shippingCountryName
            this.shippingTaxId = resp.data.data.shippingTaxId
            this.shippingTaxIdLocalName = resp.data.data.shippingTaxIdLocalName
            this.shippingEmail = resp.data.data.shippingEmail
            this.shippingLatitude = resp.data.data.shippingLatitude
            this.shippingLongitude = resp.data.data.shippingLongitude
            this.orderType = resp.data.data.type
            this.sellers = resp.data.data.sellers
            this.review = {
              'reviewRating': resp.data.data.reviewRating,
              'review': resp.data.data.review,
              'reviewFiles': resp.data.data.reviewFiles,
              'reviewDateTime': resp.data.data.reviewDateTime,
              'reviewRequestedByAdminId': resp.data.data.reviewRequestedByAdminId,
              'reviewRequestedByAdminName': resp.data.data.reviewRequestedByAdminName,
              'reviewRequestedDateTime': resp.data.data.reviewRequestedDateTime,
              'reviewSupportTicketId': resp.data.data.reviewSupportTicketId,
              'reviewReply': resp.data.data.reviewReply,
              'reviewRepliedByAdminId': resp.data.data.reviewRepliedByAdminId,
              'reviewRepliedByAdminName': resp.data.data.reviewRepliedByAdminName,
              'reviewRepliedDateTime': resp.data.data.reviewRepliedDateTime
            }
            this.payments = resp.data.data.payments
            this.paymentStatus = resp.data.data.paymentStatus
            this.paymentDiscounts = []
            if (this.paymentStatus !== 'none') {
              let methodNamesObject = {}
              let methodNames = ''
              for (var j in resp.data.data.payments) {
                // filter distinct methods only
                if (typeof methodNamesObject[resp.data.data.payments[j].paymentMethodName] === 'undefined') {
                  methodNamesObject[resp.data.data.payments[j].paymentMethodName] = resp.data.data.payments[j].paymentMethodName
                  if (methodNames !== '') {
                    methodNames = methodNames + ', '
                  }
                  methodNames = methodNames + resp.data.data.payments[j].paymentMethodName
                }

                if (resp.data.data.payments[j].feeAmountInBase < 0) {
                  this.paymentDiscounts.push(resp.data.data.payments[j])
                }
              }
              this.paymentMethodName = methodNames
            } else {
              this.paymentMethodName = resp.data.data.paymentMethodName
            }
            this.paidDateTime = resp.data.data.paidDateTime
            this.deliveryStatus = resp.data.data.deliveryStatus
            this.declareValuePercentage = resp.data.data.declareValuePercentage
            this.routing = resp.data.data.routing
            this.verifications = resp.data.data.verifications
            this.customerSelectedCourierId = resp.data.data.courierId
            this.customerSelectedServiceCode = resp.data.data.serviceCode
            this.salesOrderDeliveredDO = resp.data.data.deliveryOrders
            this.cacheBranchSalesInBase = resp.data.data.cacheBranchSalesInBase || 0
            this.cacheCostPriceInBaseFundedByHQ = resp.data.data.cacheCostPriceInBaseFundedByHQ || 0
            this.cacheBranchCostInBase = resp.data.data.cacheBranchCostInBase || 0
            this.cacheBranchCostPriceStatus = resp.data.data.cacheBranchCostPriceStatus || ''
            this.cacheBranchShippingCostInBase = resp.data.data.cacheBranchShippingCostInBase || 0
            this.cacheBranchRealShippingCostInBase = resp.data.data.cacheBranchRealShippingCostInBase || 0
            this.cacheBranchRealShippingCostStatus = resp.data.data.cacheBranchRealShippingCostStatus || ''
            this.cacheSellerFeeInBase = resp.data.data.cacheSellerFeeInBase || 0
            this.cachePaymentFeeReceivedInBase = resp.data.data.cachePaymentFeeReceivedInBase || 0
            this.cachePaymentRealFeeInBase = resp.data.data.cachePaymentRealFeeInBase || 0
            this.cachePaymentRealFeeStatus = resp.data.data.cachePaymentRealFeeStatus || ''
            this.cachePaymentCommissionInBase = resp.data.data.cachePaymentCommissionInBase || 0
            this.cachePaymentCommissionStatus = resp.data.data.cachePaymentCommissionStatus || ''
            this.cacheExtraCostInBase = resp.data.data.cacheExtraCostInBase || 0
            this.cacheProfitInBase = resp.data.data.cacheProfitInBase || 0
            this.cacheProfitStatus = resp.data.data.cacheProfitStatus || ''
            this.extraCosts = resp.data.data.extraCosts || []

            this.highlightName = this.billingFirstName + ' ' + this.billingLastName + ' ' + this.shippingFirstName + ' ' + this.shippingLastName
            this.highlightAddress = this.billingAddress + ' ' + this.shippingAddress
            this.highlightPhone = this.billingPhone + ' ' + this.shippingPhone
            this.highlightPhostCode = this.billingPostCode + ' ' + this.shippingPostCode

            if (this.paymentStatus === 'none') {
              this.paymentStatusColor = 'grey darken-2'
              this.paymentStatusIcon = 'clear'
            } else if (this.paymentStatus === 'partial') {
              this.paymentStatusColor = 'orange'
              this.paymentStatusIcon = 'opacity'
            } else if (this.paymentStatus === 'pending') {
              this.paymentStatusColor = 'orange'
              this.paymentStatusIcon = 'hourglass_empty'
            } else if (this.paymentStatus === 'in-verification') {
              this.paymentStatusColor = 'orange'
              this.paymentStatusIcon = 'policy'
            } else if (this.paymentStatus === 'paid' || this.paymentStatus === 'credit') {
              this.paymentStatusColor = 'green darken-3'
              this.paymentStatusIcon = 'done'
            } else if (this.paymentStatus === 'rejected' || this.paymentStatus === 'expired') {
              this.paymentStatusColor = 'red darken-2'
              this.paymentStatusIcon = 'clear'
            } else if (this.paymentStatus === 'chargeback') {
              this.paymentStatusColor = 'red darken-2'
              this.paymentStatusIcon = 'priority_high'
            }

            if (this.deliveryStatus === 'pending') {
              this.deliveryStatusColor = 'grey darken-2'
              this.deliveryStatusIcon = 'hourglass_empty'
            } else if (this.deliveryStatus === 'partial') {
              this.deliveryStatusColor = 'orange'
              this.deliveryStatusIcon = 'opacity'
            } else if (this.deliveryStatus === 'sent' || this.deliveryStatus === 'delivered') {
              this.deliveryStatusColor = 'green darken-3'
              this.deliveryStatusIcon = 'done'
            }

            this.events = resp.data.data.events
            this.userNotes = resp.data.data.userNotes

            this.shippingCityId = resp.data.data.shippingCityId
            this.cacheTotalWeight = resp.data.data.cacheTotalWeight

            this.exchangeRateToBase = resp.data.data.exchangeRateToBase
            this.currencyCode = resp.data.data.currencyCode
            this.currencySign = resp.data.data.currencySign
            this.currencyDecimals = resp.data.data.currencyDecimals
            this.currencyDecimalSign = resp.data.data.currencyDecimalSign
            this.deliveryCost = resp.data.data.deliveryCost
            this.importTariff = resp.data.data.importTariff
            this.vouchers = resp.data.data.vouchers
            this.cacheTotalVoucherDiscount = resp.data.data.cacheTotalVoucherDiscount
            this.cacheTotalSales = resp.data.data.cacheTotalSales

            for (var c = 0; c < resp.data.data.items.length; ++c) {
              if (resp.data.data.items[c].images.length > 0) {
                resp.data.data.items[c].image = resp.data.data.items[c].imageThumbUrl ||
                  resp.data.data.items[c].imageSmallUrl ||
                  (resp.data.data.items[c].images[0] && resp.data.data.items[c].images[0].thumbUrl) ||
                  (resp.data.data.items[c].images[0] && resp.data.data.items[c].images[0].smallUrl)
              } else {
                resp.data.data.items[c].image = ''
              }
              resp.data.data.items[c].totalPrice = resp.data.data.items[c].qty * resp.data.data.items[c].unitPrice

              // button statuses: '', disabled, saving
              resp.data.data.items[c].saveButtonStatus = 'disabled'
              resp.data.data.items[c].chkCostPrice = false
            }
            this.orderItems = resp.data.data.items

            var footers = [
              { name: 'Subtotal', total: this.formatPrice(this.cacheTotalSales, this.currencyDecimals, this.currencyDecimalSign) },
              { name: 'Shipping Cost', total: this.formatPrice(this.deliveryCost, this.currencyDecimals, this.currencyDecimalSign) },
              { name: 'Import Duties', total: this.formatPrice(this.importTariff, this.currencyDecimals, this.currencyDecimalSign) },
              { name: 'Grand Total', total: this.formatPrice(this.cacheTotalSales + this.deliveryCost + this.importTariff, this.currencyDecimals, this.currencyDecimalSign) }
            ]
            this.footers = footers

            this.$nextTick(() => {
              this.$refs.timelineDiv.scrollTop = 0
            })
          } else {
            console.log('unable to load sales order details: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(this)
            _this.loading = false
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
          }
        })
    },
    requestForVerification: function () {
      this.loading = true
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales/' + this.salesOrderNo + '/verify', {
        subject: this.txtVerificationSubject,
        bodyHtml: this.txtVerificationBodyHtml
      })
        .then(resp => {
          this.loading = false
          if (resp.data.status === 'success') {
            this.dialogVerificationRequest = false
            this.getSalesOrderDetails()
          } else {
            window.alert('unable to request for verification: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            }
            this.loading = false
          }
        })
    },
    refreshOrder: function () {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales/' + this.salesOrderNo + '/refresh')
        .then(resp => {
          this.loading = false
          if (resp.data.status === 'success') {
            // reload page
            router.go(0)
          } else {
            window.alert('unable to refresh status: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            }
            this.loading = false
          }
        })
    },
    downloadInvoice: function () {
      const _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo + '/invoice', {
        responseType: 'blob'
      })
        .then(resp => {
          _this.loading = false
          downloadjs(resp.data, _this.salesOrderNo + '-invoice.pdf', resp.headers['content-type'])
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            }
            this.loading = false
          }
        })
    }
  }
}
</script>
